import { useState, useEffect, useCallback, useContext, useMemo } from 'react';
import { Context } from '../../../context/UserContext';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import 'moment/locale/pt-br';

import { Stack, Button, Box, Tooltip, IconButton, TextField } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import DataList from '../../form/DataList';
import Input from '../../form/Input';
import Select from '../../form/Select';
import SelectEmpresa from '../../form/SelectEmpresa';
import Checkbox from '../../form/Checkbox';

import formStyles from '../../form/Form.module.css';

/* api */
import * as DataListAPI from '../../../api/dataList';
import * as EmpresaAPI from '../../../api/empresa';
import * as OperacaoAPI from '../../../api/operacao';
import * as SituacaoAPI from '../../../api/situacao';
import * as RHAPI from '../../../api/rh';
import * as TabelaAPI from '../../../api/tabela';

import { useMRTState } from '../../../hooks/useMRTState';
import { podeEditar } from '../../../hooks/usePermisionMRT';

function Form({
    token,
    dados,
    setDados,
    handleSubmit,
    btnText,
    caminhoVoltar,
    OptionsAlmoxarifado,
    OptionsDocumento,
    OptionsForma,
    OptionsPrazo,
    OptionsConta,
    EnumTipoCalculoImposto,
    EnumContador,
    EnumCancelarMovimento,
    EnumTipo,
    EnumFreteTipoPadrao,
    EnumFreteResponsavelFinanceiro,
    EnumProdutoFiltroMode,
    EnumProdutoTipo,
    OptionsNatureza,
    OptionsPlantaoTipo,
    OptionsEmpresa,
    OptionsSituacao,
    empresaId,
    empresaIds,
    empresaTabelaId,
}) {
    const { parametro } = useContext(Context);

    const mrtTransformacao = useMRTState({
        storageKey: `operacaoParametro.form.transformacao.${dados?.id || 'new'}`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });

    const mrtDocumento = useMRTState({
        storageKey: `operacaoParametro.form.documento.${dados?.id || 'new'}`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtTabelaPreco = useMRTState({
        storageKey: `operacaoParametro.form.tabelapreco.${dados?.id || 'new'}`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtSituacao = useMRTState({
        storageKey: `operacaoParametro.form.situacao.${dados?.id || 'new'}`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtOperacao = useMRTState({
        storageKey: `operacaoParametro.form.operacao.${dados?.id || 'new'}`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const [rowCountTransformacao, setRowCountTransformacao] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [rowCountTB, setRowCountTB] = useState(0);

    const [abaAtiva, setAbaAtiva] = useState(0);
    const [tabEnabled, setTabEnabled] = useState({});

    const handleSelect = (index) => {
        setAbaAtiva(index);
    };

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const operacaoParametroId = dados.id;

    const [CFOP, setCFOP] = useState(dados?.CFOP);
    const [OptionsCFOP, setOptionsCFOP] = useState([]);

    const [OptionsTabelaPreco, setOptionsTabelaPreco] = useState([]);
    const [tabelaPreco, setTabelaPrecos] = useState({
        refugo: {},
        lancamento: {},
        tabelapreco: {},
    });

    const [OptionsCC, setCC] = useState([]);
    const [OptionsLCC, setLCC] = useState([]);
    const [OptionsCCI, setCCI] = useState([]);
    const [OptionsCCSER, setCCSER] = useState([]);

    const [OptionsOperacaoEntrada, setOptionsOperacaoEntrada] = useState([]);

    const [OptionsSituacaoAlmoxarifado, setOptionsSituacaoAlmoxarifado] = useState([]);
    const [OptionsSituacaoBalanco, setOptionsSituacaoBalanco] = useState([]);
    const [OptionsSituacaoCaixa, setOptionsSituacaoCaixa] = useState([]);
    const [OptionsSituacaoFinanceiro, setOptionsSituacaoFinanceiro] = useState([]);
    const [OptionsSituacaoIndustria, setOptionsSituacaoIndustria] = useState([]);
    const [OptionsSituacaoLancamento, setOptionsSituacaoLancamento] = useState([]);
    const [OptionsSituacaoLocacao, setOptionsSituacaoLocacao] = useState([]);
    const [OptionsSituacaoLogistica, setOptionsSituacaoLogistica] = useState([]);
    const [OptionsSituacaoManutencao, setOptionsSituacaoManutencao] = useState([]);
    const [OptionsSituacaoMovimento, setOptionsSituacaoMovimento] = useState([]);
    const [OptionsSituacaoServico, setOptionsSituacaoServico] = useState([]);

    const [OptionsSituacaoDestino, setOptionsSituacaoDestino] = useState([]);
    const [OptionsOperacaoDestino, setOptionsOperacaoDestino] = useState([]);

    const [OptionsAllOperacoes, setOptionsAllOperacoes] = useState([]);
    const [OptionsAllSituacoes, setOptionsAllSituacoes] = useState([]);

    const [operacaoTransformacoes, setTransformacoes] = useState([]);
    const [operacaoParametrosDocumentos, setOperacaoParametrosDocumentos] = useState([]);
    const [operacaoTabelaPrecos, setOperacaoTabelaPrecos] = useState([]);
    const [situacaoPermitida, setSituacaoPermitida] = useState([]);
    const [operacaoPermitida, setOperacaoPermitida] = useState([]);

    const [optionsPapeisAssinatura, setOptionsPapeisAssinatura] = useState([]);
    const [papeisTransformacaoSelecionados, setPapeisTransformacaoSelecionados] = useState([]);

    const [novaTransformacao, setNovaTransformacao] = useState({
        id: null,
        uuid: null,
        ativo: true,
        funcao: 'Adicionar',
        transformaMovimento: false,
        natureza: null,
        alteraEstoque: false,
        estoque: 0,
        estoqueBloqueado: false,
        conferencia: false,
        geraFinanceiro: false,
        contabil: false,
        calculaImposto: false,
        tipoCalculoImposto: 'Nenhum',
        centroCustoLimiteBloquear: false,
        operacaoParametroId: dados.id,
        centroCustoId: null,
        lancamentoCentroCustoId: null,
        operacaoId: null,
        situacaoId: null,
        almoxarifadoId: null,
        almoxarifadoSituacaoId: null,
        lancamentoSituacaoId: null,
        situacaoIdOperacaoAnterior: null,
        permiteItemDuplicado: false,
    });

    const [novoDocumento, setNovoDocumento] = useState({
        id: null,
        uuid: null,
        empresaId: dados.empresaId,
        operacaoParametroId: dados.id,
        documentoId: null,
        ativo: true,
        funcao: 'Adicionar',
    });

    const [novaTabelaPreco, setNovaTabelaPreco] = useState({
        id: null,
        uuid: null,
        empresaId: dados.empresaId,
        operacaoParametroId: dados.id,
        tabelaPrecoId: null,
        tabelaPrecos: {},
        ativo: true,
        funcao: 'Adicionar',
    });

    const [novaSituacao, setNovaSituacao] = useState({
        id: null,
        uuid: null,
        empresaId: dados.empresaId,
        operacaoParametroId: dados.id,
        situacaoId: null,
        ativo: true,
        funcao: 'Adicionar',
    });

    const [novaOperacao, setNovaOperacao] = useState({
        id: null,
        uuid: null,
        empresaId: dados.empresaId,
        operacaoParametroId: dados.id,
        operacaoId: null,
        ativo: true,
        funcao: 'Adicionar',
    });

    // params => empresaId, tabela, id, descricao, condicao, filtro, operacao, funcionarioId
    const consultaDatalist = async (params) => {
        try {
            return await DataListAPI.dataList(params);
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };

    const consultaSituacao = async ({ empresaId, campo, campos, operacaoSigla }) => {
        if (!empresaId || !campo) {
            return;
        }

        const { data } = await SituacaoAPI.situacao({ empresaId, campo, campos, operacaoSigla });

        // Mapeamento dos campos para suas respectivas funções
        const actionMap = {
            almoxarifado: setOptionsSituacaoAlmoxarifado,
            caixa: setOptionsSituacaoCaixa,
            financeiro: setOptionsSituacaoFinanceiro,
            industria: setOptionsSituacaoIndustria,
            lancamento: setOptionsSituacaoLancamento,
            locacao: setOptionsSituacaoLocacao,
            logistica: setOptionsSituacaoLogistica,
            manutencao: setOptionsSituacaoManutencao,
            movimento: setOptionsSituacaoMovimento,
            servico: setOptionsSituacaoServico,
            destino: setOptionsSituacaoDestino, //seta a situação conforme a operação
            // Adicione mais campos e funções conforme necessário
        };

        // Verifica se existe uma função associada ao campo
        if (actionMap[campo]) {
            actionMap[campo](data); // Chama a função correspondente passando os dados
        } else {
            console.warn(`Campo desconhecido: ${campo}`); // Caso não exista, exibe um aviso
        }
    };

    const consultaOperacaoDestino = async (obj) => {
        const data = await OperacaoAPI.obterOperacaoSituacaoByOpParamId(obj);

        setOptionsOperacaoDestino(data.operacoes);
    };
    const consultaSituacaoDestino = async (obj) => {
        try {
            const data = await OperacaoAPI.obterOperacaoSituacaoByOperacaoIdEempresaId(obj);

            setOptionsSituacaoDestino(data.situacoes || []);
        } catch (error) {
            console.error('Erro ao consultar situação de destino:', error);
        }
    };
    const consultaSituacoes = async (empresaId) => {
        try {
            const data = await SituacaoAPI.situacoes(empresaTabelaId);

            setOptionsAllSituacoes(data || []);
        } catch (error) {
            console.error('Erro ao consultar situação de destino:', error);
        }
    };
    const consultaOperacoes = async () => {
        try {
            const data = await TabelaAPI.tabela(empresaTabelaId, 'Operacao', 'descricao');

            setOptionsAllOperacoes(data || []);
        } catch (error) {
            console.error('Erro ao consultar situação de destino:', error);
        }
    };
    //consulta backend
    const consultaCC = async ({ empresaId, descricao, tipo, combustivel, manutencao, industria, servico, locacao, todos }) => {
        const result = await EmpresaAPI.centroCustos(
            empresaId,
            descricao,
            tipo,
            combustivel,
            manutencao,
            industria,
            servico,
            locacao
        );

        //seleciona todos os centros de custo
        if (todos) {
            setCC(result);
        }
        //seleciona por tipo de centro de custo PAGAR ou  RECEBER
        if (tipo) {
            setLCC(result);
        }
        if (industria) {
            setCCI(result);
        }
        return result;
    };

    const carregarPapeisAssinatura = async () => {
        try {
            const result = await RHAPI.listarAssinaturaPapeis();
            setOptionsPapeisAssinatura(result || []);
        } catch (error) {
            console.error('Erro ao carregar papéis de assinatura:', error);
            setOptionsPapeisAssinatura([]);
        }
    };
    // boot
    // Inicialização das demais consultas.
    useEffect(() => {
        setCFOP(dados?.CFOP);

        consultaCC({ empresaId: dados.empresaId, todos: true });
        consultaCC({
            empresaId: dados.empresaId,
            industria: true,
            todos: false,
        });

        carregarPapeisAssinatura();
    }, []);

    // Atualiza as descrições quando as associações chegam da API.
    useEffect(() => {
        setTabelaPrecos((prev) => ({
            ...prev,
            refugo: dados?.tabelaPrecoRefugo || {},
            lancamento: dados?.TabelaPrecoLancamento || {},
        }));
    }, [dados?.tabelaPrecoRefugo, dados?.TabelaPrecoLancamento]);

    useEffect(() => {
        if (dados?.Operacao) {
            setTabEnabled({
                parametros: true,
                operacao: true,
                transformacao: dados.transformaMovimento,
                entrada: dados.Operacao.entrada,
                saida: dados.Operacao.saida,
                servico: dados.Operacao.servico,
                locacao: dados.Operacao.locacao,
                industria: dados.Operacao.industria,
                manutencao: dados.Operacao.manutencao,
                balanco: dados.Operacao.balanco,
                documento: true,
            });

            // Lista fixa de chamadas
            const tiposPadrao = [
                'almoxarifado',
                'caixa',
                'financeiro',
                'industria',
                'lancamento',
                'locacao',
                'logistica',
                'manutencao',
                'movimento',
                'servico',
            ];

            // Adiciona tipos condicionais
            //if (["LIM", "PLI"].includes(dados?.Operacao?.sigla)) tiposPadrao.push("locacao");
            //if (["SER", "OSER"].includes(dados?.Operacao?.sigla)) tiposPadrao.push("servico");
            // Executa as chamadas dinamicamente
            tiposPadrao.forEach((tipo) => consultaSituacao({ empresaId: empresaTabelaId, campo: tipo }));

            //consulta situação da operecao pelo campo
            const campo = dados.Operacao.campoSituacao;
            consultaSituacao({ empresaId: empresaTabelaId, campo });
            consultaSituacoes(empresaId);
            consultaOperacoes();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dados.Operacao, parametro]);

    useEffect(() => {
        if (!operacaoParametroId) {
            return;
        }

        consultaOperacaoDestino({ operacaoParametroId });
    }, [operacaoParametroId]);

    useEffect(() => {
        const tipo = dados.tipo || novaTransformacao.tipo;
        tipo && consultaCC({ empresaId: dados.empresaId, tipo: tipo });
    }, [dados.tipo, novaTransformacao.tipo]);

    useEffect(() => {
        //carregar a situacao do destino
        if (!novaTransformacao.operacaoId) return;
        consultaSituacaoDestino({ empresaId: empresaId, operacaoId: novaTransformacao.operacaoId });
    }, [novaTransformacao.operacaoId]);

    useEffect(() => {
        if (dados.geraFinanceiro === false) {
            setDados((prev) => ({
                ...prev,
                provisao: false,
                //lancamentoSituacaoId: null,
                //tipo: null,
                //lancamentoCentroCustoId: null,
            }));

            //deixar os options vazio
            //setLCC([]);
        }

        if (dados.alteraEstoque === false) {
            setDados((prev) => ({
                ...prev,
                estoqueNegativo: false,
                estoque: 0,
                estoqueBloqueado: false,
                situacaoIdAlmoxarifado: null,
            }));
        }

        setTabEnabled((prev) => ({ ...prev, transformacao: !!dados.transformaMovimento }));
    }, [dados.geraFinanceiro, dados.transformaMovimento, dados.alteraEstoque]);

    useEffect(() => {
        if (novaTransformacao.alteraEstoque === false) {
            setNovaTransformacao((prev) => ({
                ...prev,
                provisao: false,
                estoqueNegativo: false,
                estoque: 0,
                estoqueBloqueado: false,
                conferencia: false,
                almoxarifadoId: null,
                almoxarifadoSituacaoId: null,
            }));
        }
        if (novaTransformacao.geraFinanceiro === false) {
            setNovaTransformacao((prev) => ({
                ...prev,
                lancamentoSituacaoId: null,
                tipo: null,
                lancamentoCentroCustoId: null,
            }));
        }
    }, [novaTransformacao.alteraEstoque, novaTransformacao.geraFinanceiro]);

    //gridAtiva
    const carregarTransformacoes = useCallback(async () => {
        if (!operacaoParametroId) return;

        if (mrtTransformacao.rowCount === 0) {
            mrtTransformacao.setIsLoading(true);
        } else {
            mrtTransformacao.setIsRefetching(true);
        }

        try {
            const response = await OperacaoAPI.listarTransformacao(
                mrtTransformacao.pagination.pageIndex * mrtTransformacao.pagination.pageSize,
                mrtTransformacao.pagination.pageSize,
                JSON.stringify(mrtTransformacao.columnFilters ?? []),
                JSON.stringify(mrtTransformacao.columnFilterFns ?? {}),
                mrtTransformacao.globalFilter ?? '',
                JSON.stringify(mrtTransformacao.sorting ?? []),
                operacaoParametroId
            );

            const rows = response?.data?.data || [];
            setTransformacoes(rows);
            setRowCountTransformacao(response?.data?.meta?.totalRowCount || rows.length || 0);
            mrtTransformacao.setIsError(false);
        } catch (error) {
            console.error(error);
            mrtTransformacao.setIsError(true);
        } finally {
            mrtTransformacao.setIsLoading(false);
            mrtTransformacao.setIsRefetching(false);
        }
    }, [
        operacaoParametroId,
        mrtTransformacao.rowCount,
        mrtTransformacao.pagination.pageIndex,
        mrtTransformacao.pagination.pageSize,
        mrtTransformacao.columnFilters,
        mrtTransformacao.columnFilterFns,
        mrtTransformacao.globalFilter,
        mrtTransformacao.sorting,
    ]);

    const carregarDocumentos = useCallback(async () => {
        if (!operacaoParametroId) return;

        if (mrtDocumento.rowCount === 0) {
            mrtDocumento.setIsLoading(true);
        } else {
            mrtDocumento.setIsRefetching(true);
        }

        try {
            const response = await OperacaoAPI.listarDocumentos(
                mrtDocumento.pagination.pageIndex * mrtDocumento.pagination.pageSize,
                mrtDocumento.pagination.pageSize,
                JSON.stringify(mrtDocumento.columnFilters ?? []),
                JSON.stringify(mrtDocumento.columnFilterFns ?? {}),
                mrtDocumento.globalFilter ?? '',
                JSON.stringify(mrtDocumento.sorting ?? []),
                operacaoParametroId
            );

            const rows = response?.data?.data || [];
            setOperacaoParametrosDocumentos(rows);
            setRowCount(response?.data?.meta?.totalRowCount || rows.length || 0);
            mrtDocumento.setIsError(false);
        } catch (error) {
            console.error(error);
            mrtDocumento.setIsError(true);
        } finally {
            mrtDocumento.setIsLoading(false);
            mrtDocumento.setIsRefetching(false);
        }
    }, [
        operacaoParametroId,
        mrtDocumento.rowCount,
        mrtDocumento.pagination.pageIndex,
        mrtDocumento.pagination.pageSize,
        mrtDocumento.columnFilters,
        mrtDocumento.columnFilterFns,
        mrtDocumento.globalFilter,
        mrtDocumento.sorting,
    ]);

    const carregarTabelaPrecos = useCallback(async () => {
        if (!operacaoParametroId) return;

        if (mrtTabelaPreco.rowCount === 0) {
            mrtTabelaPreco.setIsLoading(true);
        } else {
            mrtTabelaPreco.setIsRefetching(true);
        }

        try {
            const response = await OperacaoAPI.listarTabelaPrecos(
                mrtTabelaPreco.pagination.pageIndex * mrtTabelaPreco.pagination.pageSize,
                mrtTabelaPreco.pagination.pageSize,
                JSON.stringify(mrtTabelaPreco.columnFilters ?? []),
                JSON.stringify(mrtTabelaPreco.columnFilterFns ?? {}),
                mrtTabelaPreco.globalFilter ?? '',
                JSON.stringify(mrtTabelaPreco.sorting ?? []),
                operacaoParametroId
            );

            const rows = response?.data?.data || [];
            setOperacaoTabelaPrecos(rows);
            setRowCountTB(response?.data?.meta?.totalRowCount || rows.length || 0);
            mrtTabelaPreco.setIsError(false);
        } catch (error) {
            console.error(error);
            mrtTabelaPreco.setIsError(true);
        } finally {
            mrtTabelaPreco.setIsLoading(false);
            mrtTabelaPreco.setIsRefetching(false);
        }
    }, [
        operacaoParametroId,
        mrtTabelaPreco.rowCount,
        mrtTabelaPreco.pagination.pageIndex,
        mrtTabelaPreco.pagination.pageSize,
        mrtTabelaPreco.columnFilters,
        mrtTabelaPreco.columnFilterFns,
        mrtTabelaPreco.globalFilter,
        mrtTabelaPreco.sorting,
    ]);

    const carregarSituacaoPermitida = useCallback(async () => {
        if (!operacaoParametroId) return;

        if (mrtSituacao.rowCount === 0) {
            mrtSituacao.setIsLoading(true);
        } else {
            mrtSituacao.setIsRefetching(true);
        }

        try {
            const response = await OperacaoAPI.listarSituacoes(
                mrtSituacao.pagination.pageIndex * mrtSituacao.pagination.pageSize,
                mrtSituacao.pagination.pageSize,
                JSON.stringify(mrtSituacao.columnFilters ?? []),
                JSON.stringify(mrtSituacao.columnFilterFns ?? {}),
                mrtSituacao.globalFilter ?? '',
                JSON.stringify(mrtSituacao.sorting ?? []),
                operacaoParametroId
            );

            const rows = response?.data?.data || [];
            setSituacaoPermitida(rows);
            mrtSituacao.setRowCount(response?.data?.meta?.totalRowCount || rows.length || 0);
            mrtSituacao.setIsError(false);
        } catch (error) {
            console.error(error);
            mrtSituacao.setIsError(true);
        } finally {
            mrtSituacao.setIsLoading(false);
            mrtSituacao.setIsRefetching(false);
        }
    }, [
        operacaoParametroId,
        mrtSituacao.rowCount,
        mrtSituacao.pagination.pageIndex,
        mrtSituacao.pagination.pageSize,
        mrtSituacao.columnFilters,
        mrtSituacao.columnFilterFns,
        mrtSituacao.globalFilter,
        mrtSituacao.sorting,
    ]);

    const carregarOperacaoPermitida = useCallback(async () => {
        if (!operacaoParametroId) return;

        if (mrtOperacao.rowCount === 0) {
            mrtOperacao.setIsLoading(true);
        } else {
            mrtOperacao.setIsRefetching(true);
        }

        try {
            const response = await OperacaoAPI.listarOperacoes(
                mrtOperacao.pagination.pageIndex * mrtOperacao.pagination.pageSize,
                mrtOperacao.pagination.pageSize,
                JSON.stringify(mrtOperacao.columnFilters ?? []),
                JSON.stringify(mrtOperacao.columnFilterFns ?? {}),
                mrtOperacao.globalFilter ?? '',
                JSON.stringify(mrtOperacao.sorting ?? []),
                operacaoParametroId
            );

            const rows = response?.data?.data || [];
            setOperacaoPermitida(rows);
            mrtOperacao.setRowCount(response?.data?.meta?.totalRowCount || rows.length || 0);
            mrtOperacao.setIsError(false);
        } catch (error) {
            console.error(error);
            mrtOperacao.setIsError(true);
        } finally {
            mrtOperacao.setIsLoading(false);
            mrtOperacao.setIsRefetching(false);
        }
    }, [
        operacaoParametroId,
        mrtOperacao.rowCount,
        mrtOperacao.pagination.pageIndex,
        mrtOperacao.pagination.pageSize,
        mrtOperacao.columnFilters,
        mrtOperacao.columnFilterFns,
        mrtOperacao.globalFilter,
        mrtOperacao.sorting,
    ]);

    useEffect(() => {
        dados.id && setTransformacoes((prev) => ({ ...prev, operacaoParametroId: dados.id }));
        dados.id && setOperacaoParametrosDocumentos((prev) => ({ ...prev, operacaoParametroId: dados.id }));
        dados.id && setNovaTabelaPreco((prev) => ({ ...prev, operacaoParametroId: dados.id }));
        dados.id && setNovaSituacao((prev) => ({ ...prev, situacaoId: dados.id }));
        dados.id && setNovaOperacao((prev) => ({ ...prev, operacaoId: dados.id }));
    }, [dados.id]);

    useEffect(() => {
        if (abaAtiva === 2) {
            carregarTransformacoes();
        }
    }, [abaAtiva, carregarTransformacoes]);

    useEffect(() => {
        if (abaAtiva === 10) {
            carregarDocumentos();
        }
    }, [abaAtiva, carregarDocumentos]);

    useEffect(() => {
        if (abaAtiva === 11) {
            carregarTabelaPrecos();
        }
    }, [abaAtiva, carregarTabelaPrecos]);

    useEffect(() => {
        if (abaAtiva === 12) {
            carregarSituacaoPermitida();
        }
    }, [abaAtiva, carregarSituacaoPermitida]);
    useEffect(() => {
        if (abaAtiva === 13) {
            carregarOperacaoPermitida();
        }
    }, [abaAtiva, carregarOperacaoPermitida]);

    //assim fica generico e servi para qq tabela filha
    const CreateOrEditRegistro = async (obj, tabela) => {
        let result = {};

        try {
            if (tabela === 'documento') {
                result = await OperacaoAPI.CreateOrEditDocumento(obj);
            } else if (tabela === 'tabelapreco') {
                result = await OperacaoAPI.CreateOrEditTabelaPreco(obj);
            } else if (tabela === 'transformacao') {
                result = await OperacaoAPI.CreateOrEditTransformacao(obj);
            } else if (tabela === 'situacao') {
                result = await OperacaoAPI.managerSituacao(obj);
            } else if (tabela === 'operacao') {
                result = await OperacaoAPI.managerOperacao(obj);
            }

            setFlashMessage(result.data.message, result.data.type);

            limparRegistro(tabela);
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 422) {
                // Tratar o erro 422, que é específico da validação no servidor
                setFlashMessage('Erro de validação: ' + error.response.data.message, 'error');
            } else {
                // Tratar outros erros de rede ou servidor
                setFlashMessage('Ocorreu um erro ao processar a solicitação.', 'error');
            }
        }
    };
    const handleRegistro = async (obj, tabela) => {
        let result = null;
        //incluir o numero do movimento ao objeto
        !obj.operacaoParametroId && (obj.operacaoParametroId = dados.id);

        //verificar duplicidade
        if (tabela === 'documento') {
            result = await OperacaoAPI.duplicidadeDocumento(obj.documentoId, obj.operacaoParametroId, obj.uuid);
        } else if (tabela === 'tabelapreco') {
            result = await OperacaoAPI.duplicidadeTabelaPreco(obj);
        } else if (tabela === 'transformacao') {
            result = await OperacaoAPI.duplicidadeTransformacao({
                operacaoId: obj.operacaoId,
                operacaoParametroId: obj.operacaoParametroId,
                natureza: obj.natureza,
                uuid: obj.uuid,
            });
        }

        if (obj.funcao.toLowerCase() === 'editar') {
            if (obj.uuid) {
                try {
                    if (result) {
                        setFlashMessage('Registo em duplicidade!', 'warning');
                        handleRegistroItem(result, null, 'Editar', tabela);
                        return;
                    }

                    const payload =
                        tabela === 'transformacao'
                            ? {
                                  ...obj,
                                  assinaturaPapelIds: papeisTransformacaoSelecionados,
                              }
                            : obj;

                    await CreateOrEditRegistro(payload, tabela);
                } catch (error) {
                    console.error(error);
                }
            } else {
                setOperacaoParametrosDocumentos([...operacaoParametrosDocumentos, obj]);
            }
        } else if (obj.funcao.toLowerCase() === 'cancelar') {
            try {
                let response = {};
                if (tabela === 'documento') {
                    response = await OperacaoAPI.deletarDocumento(obj.uuid);
                } else if (tabela === 'tabelapreco') {
                    response = await OperacaoAPI.deletarTabelaPreco(obj.uuid);
                } else if (tabela === 'transformacao') {
                    response = await OperacaoAPI.deletarTransformacao(obj.uuid);
                } else if (tabela === 'situacao') {
                    response = await OperacaoAPI.managerSituacao(obj);
                } else if (tabela === 'operacao') {
                    response = await OperacaoAPI.managerOperacao(obj);
                }

                setFlashMessage(response.data.message, response.data.type);
            } catch (error) {
                console.error(error);
                setFlashMessage(error.response.data.message, error.response.data.type);
            }
        } else {
            try {
                if (result && obj.funcao.toLowerCase() === 'adicionar') {
                    setFlashMessage('Registo em duplicidade!', 'warning');
                    handleRegistroItem(result, null, 'Adicionar', tabela);
                    return;
                }

                const payload =
                    tabela === 'transformacao'
                        ? {
                              ...obj,
                              assinaturaPapelIds: papeisTransformacaoSelecionados,
                          }
                        : obj;

                await CreateOrEditRegistro(payload, tabela);
            } catch (error) {
                console.error(error);
            }
        }

        limparRegistro(tabela);
    };
    const handleRegistroItem = async (originalRow, row, funcao, tabela) => {
        let newData = {};

        // Define os dados para o novo registro
        if (tabela === 'documento') {
            newData = {
                id: originalRow.id,
                uuid: originalRow.uuid,
                documentoId: originalRow.documentoId,
                operacaoParametroId: originalRow.operacaoParametroId,
                ativo: originalRow.ativo,

                funcao: funcao,
                index: row,
            };
            setNovoDocumento(newData);
            return;
        } else if (tabela === 'transformacao') {
            newData = {
                funcao: funcao,
                index: row,

                id: originalRow.id,
                uuid: originalRow.uuid,
                ativo: originalRow.ativo,

                //campos
                transformaMovimento: originalRow.transformaMovimento,
                natureza: originalRow.natureza,
                alteraEstoque: originalRow.alteraEstoque,
                estoqueNegativo: originalRow.estoqueNegativo,
                estoque: originalRow.estoque,
                estoqueBloqueado: originalRow.estoqueBloqueado,
                conferencia: originalRow.conferencia,
                geraFinanceiro: originalRow.geraFinanceiro,
                provisao: originalRow.provisao,
                tipo: originalRow.tipo,
                calculaImposto: originalRow.calculaImposto,
                tipoCalculoImposto: originalRow.tipoCalculoImposto,
                contabil: originalRow.contabil,
                centroCustoLimiteBloquear: originalRow.centroCustoLimiteBloquear,
                //campos com vinculos
                operacaoParametroId: dados.id,
                centroCustoId: originalRow.centroCustoId,
                lancamentoCentroCustoId: originalRow.lancamentoCentroCustoId,
                operacaoId: originalRow.operacaoId,
                situacaoId: originalRow.situacaoId,
                almoxarifadoSituacaoId: originalRow.almoxarifadoSituacaoId,
                lancamentoSituacaoId: originalRow.lancamentoSituacaoId,

                situacaoIdOperacaoAnterior: originalRow.situacaoIdOperacaoAnterior,
                permiteItemDuplicado: originalRow.permiteItemDuplicado,
                almoxarifadoId: originalRow.almoxarifadoId,
                //quando a operação tem multiplas origens mantem os registros do movimento anterior
                mantemOptions: originalRow.mantemOptions,
            };
            setNovaTransformacao(newData);
            setPapeisTransformacaoSelecionados(originalRow?.assinaturaPapeis?.map((item) => item.papelId) || []);
            return;
        } else if (tabela === 'tabelapreco') {
            newData = {
                id: originalRow.id,
                uuid: originalRow.uuid,
                ativo: originalRow.ativo,
                empresaId: originalRow.empresaId,
                tabelaPrecoId: originalRow.tabelaPrecoId,
                operacaoParametroId: originalRow.operacaoParametroId,
                funcao: funcao,
                index: row,
            };

            setTabelaPrecos((prev) => ({
                ...prev,
                tabelapreco: {
                    ...prev.tabelapreco,
                    descricao: originalRow.tabelaPreco?.descricao || '',
                },
            }));
            setNovaTabelaPreco(newData);
            return;
        } else if (tabela === 'situacao') {
            newData = {
                id: originalRow.id,
                uuid: originalRow.uuid,
                situacaoId: originalRow.situacaoId,
                operacaoParametroId: originalRow.operacaoParametroId,
                ativo: originalRow.ativo,

                funcao: funcao,
                index: row,
            };
            setNovaSituacao(newData);
            return;
        } else if (tabela === 'operacao') {
            newData = {
                id: originalRow.id,
                uuid: originalRow.uuid,
                operacaoId: originalRow.operacaoId,
                operacaoParametroId: originalRow.operacaoParametroId,
                ativo: originalRow.ativo,

                funcao: funcao,
                index: row,
            };
            setNovaOperacao(newData);
            return;
        }
    };
    const limparRegistro = async (tabela) => {
        let texto = 'Transformação';

        if (tabela === 'documento') {
            texto = 'Documento';
            setNovoDocumento({
                uuid: null,
                empresaId: dados.empresaId,
                documentoId: null,
                operacaoParametroId: dados.id,

                ativo: true,
                funcao: 'Adicionar',
            });
        } else if (tabela === 'tabelapreco') {
            texto = ' Tabela de Preços';
            setNovaTabelaPreco({
                uuid: null,
                empresaId: dados.empresaId,
                tabelaPrecoId: null,
                operacaoParametroId: dados.id,

                ativo: true,
                funcao: 'Adicionar',
            });
            setTabelaPrecos((prev) => ({
                ...prev,
                tabelapreco: {},
            }));
        } else if (tabela === 'transformacao') {
            setNovaTransformacao({
                id: null,
                uuid: null,
                ativo: true,
                funcao: 'Adicionar',

                //campos
                transformaMovimento: false,
                natureza: null,
                alteraEstoque: false,
                estoque: 0,
                estoqueBloqueado: false,
                conferencia: false,
                geraFinanceiro: false,
                contabil: false,
                calculaImposto: false,
                tipoCalculoImposto: 'Nenhum',
                //campos com vinculos
                operacaoParametroId: dados.id,
                centroCustoId: null,
                lancamentoCentroCustoId: null,
                operacaoId: null,
                situacaoId: null,
                almoxarifadoId: null,
                almoxarifadoSituacaoId: null,
                lancamentoSituacaoId: null,
                //tabelas vinculadas
                situacaoIdOperacaoAnterior: null,
                permiteItemDuplicado: false,
            });
            setPapeisTransformacaoSelecionados([]);
        } else if (tabela === 'situacao') {
            texto = 'Situação';
            setNovaSituacao({
                uuid: null,
                empresaId: dados.empresaId,
                situacaoId: null,
                operacaoParametroId: dados.id,

                ativo: true,
                funcao: 'Adicionar',
            });
        } else if (tabela === 'operacao') {
            texto = 'Operacao';
            setNovaOperacao({
                uuid: null,
                empresaId: dados.empresaId,
                operacaoId: null,
                operacaoParametroId: dados.id,

                ativo: true,
                funcao: 'Adicionar',
            });
        }

        if (tabela === 'transformacao') {
            await carregarTransformacoes();
        } else if (tabela === 'documento') {
            await carregarDocumentos();
        } else if (tabela === 'tabelapreco') {
            await carregarTabelaPrecos();
        } else if (tabela === 'situacao') {
            await carregarSituacaoPermitida();
        } else if (tabela === 'operacao') {
            await carregarOperacaoPermitida();
        }

        setFlashMessage(`Limpando ${texto}`, 'info');
    };

    //obter os checkbox dos papeis
    const handleTogglePapelTransformacao = (papelId) => {
        setPapeisTransformacaoSelecionados((prev) =>
            prev.includes(papelId) ? prev.filter((id) => id !== papelId) : [...prev, papelId]
        );
    };

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name.startsWith('novaTransformacao.')) {
            setNovaTransformacao({ ...novaTransformacao, [name.split('.')[1]]: type === 'checkbox' ? checked : value });
        } else if (name.startsWith('novoDocumento.')) {
            setNovoDocumento({ ...novoDocumento, [name.split('.')[1]]: type === 'checkbox' ? checked : value });
        } else if (name.startsWith('novaTabelaPreco.')) {
            setNovaTabelaPreco({ ...novaTabelaPreco, [name.split('.')[1]]: type === 'checkbox' ? checked : value });
        } else if (name.startsWith('novaSituacao.')) {
            setNovaSituacao({ ...novaSituacao, [name.split('.')[1]]: type === 'checkbox' ? checked : value });
        } else if (name.startsWith('novaOperacao.')) {
            setNovaOperacao({ ...novaOperacao, [name.split('.')[1]]: type === 'checkbox' ? checked : value });
        } else if (name.startsWith('CFOP.')) {
            setCFOP({ ...CFOP, [name.split('.')[1]]: value });

            const result = await consultaDatalist({ empresaId: dados.empresaId, tabela: 'CFOP', filtro: value });
            setOptionsCFOP(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id || null;

            setDados((prev) => ({
                ...prev,
                cfopId: selectedId,
            }));
        } else if (name.includes('tabelaPreco.descricao')) {
            // Ex.: "refugo.tabelaPreco.descricao"
            // Ignora a parte intermediária "tabelaPreco".
            const [origem, , subcampo] = name.split('.');

            setTabelaPrecos((prev) => ({
                ...prev,
                [origem]: {
                    ...prev?.[origem],
                    [subcampo]: value,
                },
            }));

            const result = await consultaDatalist({
                empresaId: dados.empresaId,
                tabela: 'tabelaPreco',
                filtro: value,
            });

            const options = Array.isArray(result) ? result : [];
            setOptionsTabelaPreco(options);

            const selectedOption = options.find((opt) => opt.descricao === value);
            const selectedId = selectedOption?.id ?? null;

            if (origem === 'tabelapreco') {
                setNovaTabelaPreco((prev) => ({
                    ...prev,
                    tabelaPrecoId: selectedId,
                }));
            } else {
                setDados((prev) => ({
                    ...prev,
                    ...(origem === 'refugo' && {
                        tabelaPrecoRefugoId: selectedId,
                    }),
                    ...(origem === 'lancamento' && {
                        lancamentoTabelaPrecoId: selectedId,
                    }),
                }));
            }
        } else {
            setDados({
                ...dados,
                [name]: type === 'checkbox' ? checked : value,
            });
        }
    }
    async function handleOnBlur(e) {}
    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    //ajustta o tottal de registros na grid
    useEffect(() => {
        if (operacaoTransformacoes) {
            setRowCountTransformacao(operacaoTransformacoes.length);
        }
        if (operacaoParametrosDocumentos) {
            setRowCount(operacaoParametrosDocumentos.length);
        }
    }, [operacaoTransformacoes, operacaoParametrosDocumentos]);
    //criar a grid
    const columnsTransformacao = useMemo(
        () => [
            {
                id: 'transformar',
                header: `Operações disponíveis para transformar`,
                columns: [
                    {
                        accessorKey: 'Operacao.descricao',
                        header: 'Operação',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'natureza',
                        header: 'Natureza',
                    },
                    {
                        accessorKey: 'Situacao.descricao',
                        header: 'Situação',
                        muiTableBodyCellProps: {
                            align: 'left',
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );
    const columnsDocumento = useMemo(
        () => [
            {
                id: 'documento',
                header: `Documentos modelo para relatórios`,
                columns: [
                    {
                        accessorKey: 'Documento.descricao',
                        header: 'Documento modelo',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'Documento.caminho',
                        header: 'Caminho',
                        muiTableBodyCellProps: {
                            align: 'left',
                        },
                    },
                    {
                        accessorKey: 'Documento.funcao',
                        header: 'Função',
                        muiTableBodyCellProps: {
                            align: 'left',
                        },
                    },
                    {
                        accessorKey: 'Documento.tipo',
                        header: 'Tipo',
                        muiTableBodyCellProps: {
                            align: 'left',
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );
    const columnsTabelaPreco = useMemo(
        () => [
            {
                id: 'tabelaPreco',
                header: `Tabela de Preços`,
                columns: [
                    {
                        accessorKey: 'Empresa.nomeFantasia',
                        header: 'Empresa',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'tabelaPreco.descricao',
                        header: 'Tabela de Preço',
                        muiTableBodyCellProps: {
                            align: 'left',
                        },
                    },
                    {
                        accessorKey: 'tabelaPreco.referencia',
                        header: 'Referência',
                        muiTableBodyCellProps: {
                            align: 'left',
                        },
                    },
                    {
                        accessorKey: 'tabelaPreco.entrada',
                        header: 'Entrada',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original?.tabelaPreco.entrada;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'tabelaPreco.saida',
                        header: 'Saída',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original?.tabelaPreco.saida;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );
    const columnsSituacao = useMemo(
        () => [
            {
                id: 'situacao',
                header: `Situações Permitidas`,
                columns: [
                    {
                        accessorKey: 'Situacao.descricao',
                        header: 'Situação',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );
    const columnsOperacao = useMemo(
        () => [
            {
                id: 'operacao',
                header: `Operações Permitidas`,
                columns: [
                    {
                        accessorKey: 'Operacao.descricao',
                        header: 'Operação',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );
    const theme = tableThemeCustom();

    return (
        <div>
            <Tabs selectedIndex={abaAtiva} onSelect={handleSelect}>
                <form onSubmit={submit}>
                    <h1>{`Parâmetros ${dados?.Operacao?.descricao + ' - ' + dados?.Operacao?.sigla}`}</h1>
                    <TabList>
                        <Tab disabled={!tabEnabled.parametros} title={'Parâmetros comuns as operações'}>
                            Parâmetros
                        </Tab>
                        <Tab disabled={!tabEnabled.operacao} title={'Parâmetros da Operação'}>
                            Operação
                        </Tab>
                        <Tab disabled={!tabEnabled.transformacao} title={'Parâmetros de transformação da Operação'}>
                            Transformação
                        </Tab>
                        <Tab disabled={!tabEnabled.entrada} title={'Parâmetros de operações de Entradas'}>
                            Entradas
                        </Tab>
                        <Tab disabled={!tabEnabled.saida} title={'Parâmetros de operações de Saídas'}>
                            Saídas
                        </Tab>
                        <Tab disabled={!tabEnabled.servico} title={'Parâmetros de operações de  Serviço'}>
                            Serviço
                        </Tab>
                        <Tab disabled={!tabEnabled.locacao} title={'Parâmetros de operações de  Locação'}>
                            Locação
                        </Tab>
                        <Tab disabled={!tabEnabled.industria} title={'Parâmetros de operações de Indústria'}>
                            Indústria
                        </Tab>
                        <Tab disabled={!tabEnabled.manutencao} title={'Parâmetros de operações de Manutenção'}>
                            Manutenção
                        </Tab>
                        <Tab disabled={!tabEnabled.balanco} title={'Parâmetros da operação de balanço'}>
                            Balanço
                        </Tab>
                        <Tab
                            disabled={!tabEnabled.documento}
                            title={'Parâmetros dos modelos de relatórios vinculados a operação'}
                        >
                            Documento Modelo
                        </Tab>
                        <Tab title={'Tabelas de preços vinculadas a operação'}>Tabelas de Preços</Tab>
                        <Tab title={'Situações permitidas'}>Situações</Tab>
                        <Tab title={'Operações permitidas'}>Operações</Tab>
                    </TabList>
                    {/* parametros */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros da Operação</h4>
                            <fieldset style={{ margin: '16px 0', padding: 16 }}>
                                <legend>Condições de cobrança em lote</legend>
                                <Checkbox
                                    name="loteUsaFinanceiroPessoa"
                                    text="Usar configurações financeiras da Pessoa no lote"
                                    title="Marcado: usa o financeiro da Pessoa e completa campos ausentes com os padrões da operação. Desmarcado: usa somente a operação."
                                    handleOnChange={handleChange}
                                    value={dados.loteUsaFinanceiroPessoa}
                                    checked={[true, 1, '1', 'true'].includes(dados.loteUsaFinanceiroPessoa)}
                                />
                                <p>
                                    Marcado: usa o financeiro da Pessoa, com os padrões da operação para campos ausentes.
                                    Desmarcado: usa somente a operação.
                                </p>
                                <Stack direction="row" useFlexGap flexWrap="wrap" spacing={2}>
                                    <TextField
                                        size="small"
                                        name="cobrancaDescontoPontualidadePercentual"
                                        label="Desconto por pontualidade (%)"
                                        value={dados?.cobrancaDescontoPontualidadePercentual ?? 0}
                                        onChange={handleChange}
                                        helperText="Concedido até o vencimento, sem reduzir o principal antecipadamente. Zero não aplica desconto."
                                        title="Concedido até o vencimento, sem reduzir o principal antecipadamente. Zero não aplica desconto."
                                        inputProps={{ inputMode: 'decimal' }}
                                        sx={{ width: 300, maxWidth: '100%' }}
                                    />
                                    <TextField
                                        size="small"
                                        name="cobrancaMultaPercentual"
                                        label="Multa por atraso (%)"
                                        value={dados?.cobrancaMultaPercentual ?? 0}
                                        onChange={handleChange}
                                        helperText="Aplicada uma única vez após o vencimento. Zero não aplica multa."
                                        title="Aplicada uma única vez após o vencimento. Zero não aplica multa."
                                        inputProps={{ inputMode: 'decimal' }}
                                        sx={{ width: 300, maxWidth: '100%' }}
                                    />
                                    <TextField
                                        size="small"
                                        name="cobrancaJurosMensalPercentual"
                                        label="Juros ao mês (%)"
                                        value={dados?.cobrancaJurosMensalPercentual ?? 0}
                                        onChange={handleChange}
                                        helperText="Calculados proporcionalmente aos dias de atraso. Zero não aplica juros."
                                        title="Calculados proporcionalmente aos dias de atraso. Zero não aplica juros."
                                        inputProps={{ inputMode: 'decimal' }}
                                        sx={{ width: 300, maxWidth: '100%' }}
                                    />
                                    <TextField
                                        size="small"
                                        name="cobrancaLimiteRecebimentoDias"
                                        label="Prazo após vencimento (dias)"
                                        value={dados?.cobrancaLimiteRecebimentoDias ?? ''}
                                        onChange={handleChange}
                                        helperText="Define a data de não receber após. Vazio não define limite; zero limita ao próprio vencimento."
                                        title="Define a data de não receber após. Vazio não define limite; zero limita ao próprio vencimento."
                                        inputProps={{ inputMode: 'numeric' }}
                                        sx={{ width: 300, maxWidth: '100%' }}
                                    />
                                </Stack>
                            </fieldset>
                            <div>
                                <div>
                                    <Select
                                        name="campoContador"
                                        title="Define o contador da operação pela sigla, é número do movimento"
                                        text="Contador"
                                        inputWidth="150px"
                                        options={EnumContador}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.campoContador}
                                        isEnum={true}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="situacaoId"
                                        title="Define a situação padrão do movimento"
                                        text="Situação Movimento"
                                        inputWidth="170px"
                                        options={OptionsSituacao}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.situacaoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Checkbox
                                        title="Não permite alterar a situação no movimento"
                                        text="Desabilita"
                                        name="situacaoIdIsDisabled"
                                        handleOnChange={handleChange}
                                        value={dados.situacaoIdIsDisabled}
                                        checked={!!dados.situacaoIdIsDisabled}
                                    />
                                    <Select
                                        name="centroCustoId"
                                        title={'Define o centro de custo padrão para o movimento'}
                                        text="Centro Custo"
                                        inputWidth="200px"
                                        options={OptionsCC}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.centroCustoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Checkbox
                                        title="Quando marcado nas operações de movimento indica que o formulário padrão terá consulta de produtos para inclusão limitada a tabela de preço, caso desmarcado a consulta será por produto livre da tabela de preço, em casos que são poucos itens é mais fácil a consulta pela tabela."
                                        text="Formulário"
                                        name="formTabelaOrProduto"
                                        handleOnChange={handleChange}
                                        value={dados.formTabelaOrProduto}
                                        checked={!!dados.formTabelaOrProduto}
                                    />
                                    <Checkbox
                                        title="O movimento exige item para ser salvo, caso contrário o movimento pode ser salvo sem itens e depois editado para inclusão dos itens"
                                        text="Exige Item"
                                        name="exigeItem"
                                        handleOnChange={handleChange}
                                        value={dados.exigeItem}
                                        checked={!!dados.exigeItem}
                                    />
                                    <Checkbox
                                        title="Informa que a operação gera demanda de produção, movimentos nesta operação constituem ordem de produção na indústria"
                                        text="Gera Produção"
                                        name="geraDemandaProducao"
                                        handleOnChange={handleChange}
                                        value={dados.geraDemandaProducao}
                                        checked={!!dados.geraDemandaProducao}
                                    />
                                    <Checkbox
                                        title="Utiliza pedido padrão, quando selecionado aparece no movimento a opção de cadastrar um pedido padrão para o cliente"
                                        text="Pedido Padrão"
                                        name="usaPedidoPadrao"
                                        handleOnChange={handleChange}
                                        value={dados.usaPedidoPadrao}
                                        checked={!!dados.usaPedidoPadrao}
                                    />
                                </div>
                                <div>
                                    {' '}
                                    <Checkbox
                                        title="Mostrar opção de listar o relatório de curva ABC na rotina de movimento"
                                        text="Curva ABC"
                                        name="curvaABC"
                                        handleOnChange={handleChange}
                                        value={dados.curvaABC}
                                        checked={!!dados.curvaABC}
                                    />
                                    <Checkbox
                                        title="Mostrar opção de escolher empresa no movimento"
                                        text="Mostrar Empresa"
                                        name="showEmpresaNoMovimento"
                                        handleOnChange={handleChange}
                                        value={dados.showEmpresaNoMovimento}
                                        checked={!!dados.showEmpresaNoMovimento}
                                    />
                                    <Checkbox
                                        title="obriga o movimento a funcionar apenas com plantão aberto"
                                        text="Plantão"
                                        name="plantao"
                                        handleOnChange={handleChange}
                                        value={dados.plantao}
                                        checked={!!dados.plantao}
                                    />
                                    <Select
                                        name="plantaoTipoId"
                                        title="Selecione o tipo"
                                        text="Tipo"
                                        inputWidth="150px"
                                        options={OptionsPlantaoTipo}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.plantaoTipoId}
                                        notOptNull={false}
                                    />
                                </div>
                                {dados?.Operacao?.sigla === 'REST' && (
                                    <div>
                                        <Checkbox
                                            title="Quando marcado utiliza a regra de horários das refeições, limitando os produtos conforme configurado na tabela de preços"
                                            text="Utiliza"
                                            name="utilizaRegraHoraMax"
                                            handleOnChange={handleChange}
                                            value={dados.utilizaRegraHoraMax}
                                            checked={!!dados.utilizaRegraHoraMax}
                                        />
                                        <Input
                                            text="Café"
                                            type="time"
                                            name="horaMaxCafe"
                                            placeholder="Hora café"
                                            title="hora máxima do café da manhã"
                                            handleOnChange={handleChange}
                                            handleOnFocus={handleOnFocus}
                                            handleOnBlur={handleOnBlur}
                                            value={dados.horaMaxCafe}
                                        />
                                        <Input
                                            text="Almoço"
                                            type="time"
                                            name="horaMaxAlmoco"
                                            placeholder="Hora almoço"
                                            title="hora máxima do almoço"
                                            handleOnChange={handleChange}
                                            handleOnFocus={handleOnFocus}
                                            handleOnBlur={handleOnBlur}
                                            value={dados.horaMaxAlmoco}
                                        />
                                        <Input
                                            text="Jantar"
                                            type="time"
                                            name="horaMaxJanta"
                                            placeholder="Hora jantar"
                                            title="hora máxima do jantar"
                                            handleOnChange={handleChange}
                                            handleOnFocus={handleOnFocus}
                                            handleOnBlur={handleOnBlur}
                                            value={dados.horaMaxJanta}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </TabPanel>
                    {/* Operação */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros da Operação na digitação</h4>
                            <div>
                                <div>
                                    <Checkbox
                                        title="Permite inserir itens duplicados no movimento"
                                        text="Item"
                                        name="permiteItemDuplicado"
                                        handleOnChange={handleChange}
                                        value={dados.permiteItemDuplicado}
                                        checked={!!dados.permiteItemDuplicado}
                                    />
                                    <Checkbox
                                        title="Configura a formatação da operação para suportar 3 digitos, utilizado para unidades pequenas exemplo: 0,985 Kg com 2 digitos não seria possível"
                                        text="3 dig"
                                        name="utiliza3digitos"
                                        handleOnChange={handleChange}
                                        value={dados.utiliza3digitos}
                                        checked={!!dados.utiliza3digitos}
                                    />

                                    <Checkbox
                                        title="Permite transformar o movimento"
                                        text="Transformar"
                                        name="transformaMovimento"
                                        handleOnChange={handleChange}
                                        value={dados.transformaMovimento}
                                        checked={!!dados.transformaMovimento}
                                    />
                                    <Checkbox
                                        title="Operação atualiza o financeiro"
                                        text="Gera Financeiro"
                                        name="geraFinanceiro"
                                        handleOnChange={handleChange}
                                        value={dados.geraFinanceiro}
                                        checked={!!dados.geraFinanceiro}
                                    />
                                    <Checkbox
                                        title="Operação atualiza o financeiro e o lançamento será provisionado"
                                        text="Provisão"
                                        name="provisao"
                                        handleOnChange={handleChange}
                                        value={dados.provisao}
                                        checked={!!dados.provisao}
                                    />
                                    <Select
                                        name="lancamentoSituacaoId"
                                        title="Define a situação padrão do lançamento"
                                        text="Situação Lançamento"
                                        inputWidth="170px"
                                        options={OptionsSituacaoLancamento}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.lancamentoSituacaoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="tipo"
                                        title="Tipo do lançamento do financeiro PAGAR ou RECEBER"
                                        text="Tipo"
                                        inputWidth="150px"
                                        options={EnumTipo}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.tipo}
                                        isEnum={true}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="lancamentoFormaId"
                                        title={'Define a forma padrão para o lançamento'}
                                        text="Forma"
                                        inputWidth="150px"
                                        options={OptionsForma}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.lancamentoFormaId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="lancamentoPrazoId"
                                        title={'Define o prazo padrão para o lançamento'}
                                        text="Prazo"
                                        inputWidth="150px"
                                        options={OptionsPrazo}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.lancamentoPrazoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="lancamentoContaId"
                                        title={'Define a conta padrão para o lançamento'}
                                        text="Conta"
                                        inputWidth="150px"
                                        options={OptionsConta}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.lancamentoContaId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <DataList
                                        text="Tabela de Preços"
                                        title={'Digite para selecionar a tabela de preço, aplicada no lançamento padrão'}
                                        placeholder="Tabela de preço"
                                        name="lancamento.tabelaPreco.descricao"
                                        inputWidth="150px"
                                        filteredOptions={OptionsTabelaPreco}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={tabelaPreco?.lancamento?.descricao || ''}
                                    />
                                    <Select
                                        name="lancamentoCentroCustoId"
                                        title={'Define o centro de custo padrão para o lançamento'}
                                        text="Centro Custo"
                                        inputWidth="150px"
                                        options={OptionsLCC}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.lancamentoCentroCustoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                </div>
                                <div>
                                    <Checkbox
                                        title="Calcular Impostos no item"
                                        text="Calc Imposto"
                                        name="calculaImposto"
                                        handleOnChange={handleChange}
                                        value={dados.calculaImposto}
                                        checked={!!dados.calculaImposto}
                                    />
                                    <Select
                                        name="tipoCalculoImposto"
                                        title="Tipo do cálculo do imposto"
                                        text="Tipo Cálculo"
                                        inputWidth="150px"
                                        options={EnumTipoCalculoImposto}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.tipoCalculoImposto}
                                        isEnum={true}
                                        notOptNull={true}
                                    />
                                    <Checkbox
                                        title="Operação contábil"
                                        text="Contábil"
                                        name="contabil"
                                        handleOnChange={handleChange}
                                        value={dados.contabil}
                                        checked={!!dados.contabil}
                                    />
                                    <DataList
                                        text="CFOP Descrição"
                                        title={'Vincula o CFOP a operação'}
                                        name="CFOP.descricao"
                                        placeholder={'Digite mais de 3 caracteres para pesquisar'}
                                        inputWidth="300px"
                                        filteredOptions={OptionsCFOP}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={CFOP?.descricao}
                                        required={false}
                                    />
                                    <Select
                                        name="cancelarMovimento"
                                        title="Quando cancelar um movimento e o mesmo tiver lançamento parcialmente baixado o restante do saldo do lançamento será MANTIDO ou LIQUIDADO"
                                        text="Cancelar Movimento"
                                        inputWidth="150px"
                                        options={EnumCancelarMovimento}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.cancelarMovimento}
                                        isEnum={true}
                                        notOptNull={false}
                                    />
                                    <Checkbox
                                        title="Bloquear o movimento por limite de centro de custo"
                                        text="Bloquear por centro de custo"
                                        name="centroCustoLimiteBloquear"
                                        handleOnChange={handleChange}
                                        value={dados.centroCustoLimiteBloquear}
                                        checked={!!dados.centroCustoLimiteBloquear}
                                    />

                                    <Checkbox
                                        title="Bloquear o movimento por limite de centro de custo na digitação"
                                        text="Bloquear na digitação"
                                        name="centroCustoLimiteBloquearNaDigitacao"
                                        handleOnChange={handleChange}
                                        value={dados.centroCustoLimiteBloquearNaDigitacao}
                                        checked={!!dados.centroCustoLimiteBloquearNaDigitacao}
                                    />
                                </div>
                            </div>
                            <h4>Parâmetros de Custos</h4>
                            <div>
                                <Checkbox
                                    title="Ao selecionar o produto no movimento o sistema permite gravar o movimento sem preço e será incluído o último custo do produto."
                                    text="Último Custo"
                                    name="ultimoCusto"
                                    handleOnChange={handleChange}
                                    value={dados.ultimoCusto}
                                    checked={!!dados.ultimoCusto}
                                />
                                <Checkbox
                                    title="Informa que a operação compõe custo do produto e será informado nas funções de obter custo do produto"
                                    text="Custo Produto"
                                    name="compoeCustoProduto"
                                    handleOnChange={handleChange}
                                    value={dados.compoeCustoProduto}
                                    checked={!!dados.compoeCustoProduto}
                                />
                            </div>
                            <h4>Parâmetros de custos almoço de colaboradores</h4>
                            <div>
                                <Checkbox
                                    title="o almoço dos colaboradores vai gerar um custo financeiro para empresa contratante do colaborador"
                                    text="almoço gera custo"
                                    name="almocoColaboradorGeraFinanceiro"
                                    handleOnChange={handleChange}
                                    value={dados.almocoColaboradorGeraFinanceiro}
                                    checked={!!dados.almocoColaboradorGeraFinanceiro}
                                />
                                <Checkbox
                                    title="o almoço dos colaboradores da própria empresa será provisionado no financeiro, ou seja, não gera um lançamento a pagar, mas gera um lançamento provisionado para controle interno de custos da empresa"
                                    text="Provisão"
                                    name="almocoProvisionado"
                                    handleOnChange={handleChange}
                                    value={dados.almocoProvisionado}
                                    checked={!!dados.almocoProvisionado}
                                />
                                <Select
                                    name="almocoCustoCentroCustoId"
                                    title={
                                        'Define o centro de custo para o lançamento do almoço do colaborador da própria empresa'
                                    }
                                    text="Centro Custo"
                                    inputWidth="200px"
                                    options={OptionsLCC}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.almocoCustoCentroCustoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="almocoCustoContaId"
                                    title={'Define a conta para o lançamento do almoço do colaborador da própria empresa'}
                                    text="Conta"
                                    inputWidth="150px"
                                    options={OptionsConta}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.almocoCustoContaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="o almoço dos colaboradores da filial será provisionado no financeiro, ou seja, não gera um lançamento a pagar, mas gera um lançamento provisionado para controle interno de custos da empresa"
                                    text="Provisão"
                                    name="almocoFilialProvisionado"
                                    handleOnChange={handleChange}
                                    value={dados.almocoFilialProvisionado}
                                    checked={!!dados.almocoFilialProvisionado}
                                />
                                <Select
                                    name="custoFilialCentroCustoId"
                                    title={
                                        'Define o centro de custo para o lançamento do custo na filial, ocorre quando um lançamento gera um outro lançamento invertido na filial, tipo na origem do lançamento é um contas a RECEBER e vai ser lançado um espelho na filial de contas a PAGAR'
                                    }
                                    text="Filial Centro Custo"
                                    inputWidth="200px"
                                    options={OptionsLCC}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.custoFilialCentroCustoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="custoFilialContaId"
                                    title={'Define a conta para o lançamento do custo na filial'}
                                    text="Filial Conta"
                                    inputWidth="150px"
                                    options={OptionsConta}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.custoFilialContaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                            <h4>Parâmetros de FRETE</h4>
                            <div>
                                <Checkbox
                                    title="Quando marcado o frete deverá gera o lançamento no modulo financeiro"
                                    text="Gera Financeiro"
                                    name="freteGeraFinanceiro"
                                    handleOnChange={handleChange}
                                    value={dados.freteGeraFinanceiro}
                                    checked={!!dados.freteGeraFinanceiro}
                                />
                                <Checkbox
                                    title="Quando marcado o frete deverá gera o lançamento no modulo financeiro provisionado"
                                    text="Provisão"
                                    name="freteProvisao"
                                    handleOnChange={handleChange}
                                    value={dados.freteProvisao}
                                    checked={!!dados.freteProvisao}
                                />
                                <Select
                                    name="freteTipoPadrao"
                                    title="Informa o tipo do frete CIF/FOB"
                                    text="Tipo"
                                    inputWidth="150px"
                                    options={EnumFreteTipoPadrao}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.freteTipoPadrao}
                                    isEnum={true}
                                    notOptNull={true}
                                />
                                <Select
                                    name="freteResponsavelFinanceiro"
                                    title="Informa o responsável financeiro pelo lançamento do frete"
                                    text="Responsável"
                                    inputWidth="150px"
                                    options={EnumFreteResponsavelFinanceiro}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.freteResponsavelFinanceiro}
                                    isEnum={true}
                                    notOptNull={true}
                                />
                                <Select
                                    name="freteFormaId"
                                    title={'Define a forma padrão para o lançamento'}
                                    text="Forma"
                                    inputWidth="150px"
                                    options={OptionsForma}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.freteFormaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="fretePrazoId"
                                    title={'Define o prazo padrão para o lançamento'}
                                    text="Prazo"
                                    inputWidth="150px"
                                    options={OptionsPrazo}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.fretePrazoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="freteContaId"
                                    title={'Define a conta padrão para o lançamento'}
                                    text="Conta"
                                    inputWidth="150px"
                                    options={OptionsConta}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.freteContaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="freteCentroCustoId"
                                    title={'Define o centro de custo padrão para o lançamento'}
                                    text="Centro Custo"
                                    inputWidth="200px"
                                    options={OptionsCC}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.freteCentroCustoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Informa que o valor do frete deverá ser rateado nos custos dos itens"
                                    text="Rateia Custo"
                                    name="freteRateiaNoCustoItem"
                                    handleOnChange={handleChange}
                                    value={dados.freteRateiaNoCustoItem}
                                    checked={!!dados.freteRateiaNoCustoItem}
                                />
                                <Checkbox
                                    title="Informa que o valor do frete irá compor o preço de venda dos produtos"
                                    text="Compõe PV"
                                    name="freteInfluiPrecoVenda"
                                    handleOnChange={handleChange}
                                    value={dados.freteInfluiPrecoVenda}
                                    checked={!!dados.freteInfluiPrecoVenda}
                                />
                                <Checkbox
                                    title="Permite gerar multiplos fretes"
                                    text="Multiplo"
                                    name="fretePermiteMultiplo"
                                    handleOnChange={handleChange}
                                    value={dados.fretePermiteMultiplo}
                                    checked={!!dados.fretePermiteMultiplo}
                                />
                            </div>
                            <h4>Parâmetros de filtros de produtos</h4>
                            <div>
                                <Checkbox
                                    title="indica que o filtro de produto BEM"
                                    text="BEM"
                                    name="produto_bem"
                                    handleOnChange={handleChange}
                                    value={dados.produto_bem}
                                    checked={!!dados.produto_bem}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto COMPRA"
                                    text="Compra"
                                    name="produto_compra"
                                    handleOnChange={handleChange}
                                    value={dados.produto_compra}
                                    checked={!!dados.produto_compra}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto IMÒVELl"
                                    text="Imóvel"
                                    name="produto_imovel"
                                    handleOnChange={handleChange}
                                    value={dados.produto_imovel}
                                    checked={!!dados.produto_imovel}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto INDÚSTRIA"
                                    text="Indústria"
                                    name="produto_industria"
                                    handleOnChange={handleChange}
                                    value={dados.produto_industria}
                                    checked={!!dados.produto_industria}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto LOCÁVEL"
                                    text="Locável"
                                    name="produto_locavel"
                                    handleOnChange={handleChange}
                                    value={dados.produto_locavel}
                                    checked={!!dados.produto_locavel}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto Matéria-Prima"
                                    text="Matéria-Prima"
                                    name="produto_materiaPrima"
                                    handleOnChange={handleChange}
                                    value={dados.produto_materiaPrima}
                                    checked={!!dados.produto_materiaPrima}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto Serviço"
                                    text="Serviço"
                                    name="produto_servico"
                                    handleOnChange={handleChange}
                                    value={dados.produto_servico}
                                    checked={!!dados.produto_servico}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto VENDA"
                                    text="Venda"
                                    name="produto_venda"
                                    handleOnChange={handleChange}
                                    value={dados.produto_venda}
                                    checked={!!dados.produto_venda}
                                />
                                <Checkbox
                                    title="indica que o filtro de produto Veículo"
                                    text="VTR"
                                    name="produto_vtr"
                                    handleOnChange={handleChange}
                                    value={dados.produto_vtr}
                                    checked={!!dados.produto_vtr}
                                />
                                <Select
                                    name="produto_tipo"
                                    title="Informa o tipo do produto para o filtro"
                                    text="Tipo"
                                    inputWidth="150px"
                                    options={EnumProdutoTipo}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.produto_tipo}
                                    isEnum={true}
                                    notOptNull={false}
                                />
                                <Select
                                    name="produtoFiltroMode"
                                    title="Informa o modo do filtro para a sql(sequelize)"
                                    text="Filter Mode"
                                    inputWidth="150px"
                                    options={EnumProdutoFiltroMode}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.produtoFiltroMode}
                                    isEnum={true}
                                    notOptNull={true}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    {/* Transformação */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros da Operação na Transformação</h4>
                            <div>
                                <div
                                    style={{
                                        //display: "flex",
                                        alignItems: 'center',
                                    }}
                                >
                                    <Checkbox
                                        title="Permite transformar o movimento"
                                        text="Transformar"
                                        name="novaTransformacao.transformaMovimento"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.transformaMovimento}
                                        checked={!!novaTransformacao.transformaMovimento}
                                    />
                                    <Checkbox
                                        title="Permite inserir itens duplicados no movimento"
                                        text="Item"
                                        name="novaTransformacao.permiteItemDuplicado"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.permiteItemDuplicado}
                                        checked={!!novaTransformacao.permiteItemDuplicado}
                                    />
                                    <Select
                                        name="novaTransformacao.natureza"
                                        title="Criar vínculo com o menu do movimento e a operação transformação quando existe ambiguidade de transformações"
                                        text="Natureza"
                                        inputWidth="150px"
                                        options={OptionsNatureza}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.natureza}
                                        isEnum={true}
                                        notOptNull={false}
                                    />

                                    <Select
                                        name="novaTransformacao.situacaoIdOperacaoAnterior"
                                        title="Define a situação da operação anterior ou seja, do movimento transformado"
                                        text="Situação Mov. Anterior"
                                        inputWidth="170px"
                                        options={OptionsSituacao}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.situacaoIdOperacaoAnterior}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Select
                                        title="Operação de destino ao transformar"
                                        text="Operação Destino"
                                        name="novaTransformacao.operacaoId"
                                        options={OptionsOperacaoDestino}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.operacaoId}
                                        isEnum={false}
                                        notOptNull={false}
                                        required={false}
                                        inputWidth={'170px'}
                                    />
                                    <Select
                                        name="novaTransformacao.situacaoId"
                                        title="Define a situação padrão do movimento destino"
                                        text="Situação Destino"
                                        inputWidth="170px"
                                        options={OptionsSituacaoDestino}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.situacaoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Checkbox
                                        title="Quando a operação tem multiplas origens, selecione esta opção para a transformação manter o centro de custo, almoxarifado, centro de custo do lançamento, etc. do movimento original"
                                        text="Mantém opções"
                                        name="novaTransformacao.mantemOptions"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.mantemOptions}
                                        checked={!!novaTransformacao.mantemOptions}
                                    />
                                    <Select
                                        name="novaTransformacao.centroCustoId"
                                        title="Define o centro de custo padrão do movimento destino"
                                        text="Centro de Custo Destino"
                                        inputWidth="200px"
                                        options={OptionsCC}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.centroCustoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                </div>
                                <div>
                                    <Checkbox
                                        title="operação de destino altera estoque"
                                        text="Altera Estoque"
                                        name="novaTransformacao.alteraEstoque"
                                        handleOnChange={handleChange}
                                        value={!novaTransformacao.transformaMovimento ? false : novaTransformacao.alteraEstoque}
                                        checked={!!novaTransformacao.alteraEstoque}
                                    />
                                    <Checkbox
                                        title="Verifica o estoque na operação de destino e valida o saldo, caso a opção esteja marcada vai permitir com saldo negativo"
                                        text="Estoque Negativo"
                                        name="novaTransformacao.estoqueNegativo"
                                        handleOnChange={handleChange}
                                        value={!novaTransformacao.transformaMovimento ? false : novaTransformacao.estoqueNegativo}
                                        checked={!!novaTransformacao.estoqueNegativo}
                                    />
                                    <Input
                                        text="Estoque Destino"
                                        type="range"
                                        name="novaTransformacao.estoque"
                                        inputWidth="100px"
                                        title="configura o valor que a operação altera o estoque, -1 subtrai, 0 não altera e 1 acrescenta"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={!novaTransformacao.alteraEstoque ? 0 : novaTransformacao.estoque}
                                        textAlign="center"
                                        min={-1}
                                        max={1}
                                    />
                                    <Checkbox
                                        title="Estoque bloqueado na operação de destino"
                                        text="Estoque Bloqueado"
                                        name="novaTransformacao.estoqueBloqueado"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.estoqueBloqueado}
                                        checked={!!novaTransformacao.estoqueBloqueado}
                                    />
                                    <Checkbox
                                        title="Obriga conferência na operação de destino"
                                        text="Conferência"
                                        name="novaTransformacao.conferencia"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.conferencia}
                                        checked={!!novaTransformacao.conferencia}
                                    />
                                    <Select
                                        name="novaTransformacao.almoxarifadoId"
                                        title="Define o almoxarifado padrão para a operação de destino"
                                        text="Almoxarifado"
                                        inputWidth="170px"
                                        options={OptionsAlmoxarifado}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.almoxarifadoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="novaTransformacao.almoxarifadoSituacaoId"
                                        title="Define a situação de entrada no almoxarifado para a operação de destino"
                                        text="Situação Alm Destino"
                                        inputWidth="170px"
                                        options={OptionsSituacaoAlmoxarifado}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.almoxarifadoSituacaoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Checkbox
                                        title="gera o financeiro na operação de destino"
                                        text="Gera Financeiro"
                                        name="novaTransformacao.geraFinanceiro"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.geraFinanceiro}
                                        checked={!!novaTransformacao.geraFinanceiro}
                                    />
                                    <Checkbox
                                        title="Lançamento será provisionado"
                                        text="Provisão"
                                        name="novaTransformacao.provisao"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.provisao}
                                        checked={!!novaTransformacao.provisao}
                                    />
                                    <Select
                                        name="novaTransformacao.lancamentoSituacaoId"
                                        title="Define a situação padrão do lançamento destino"
                                        text="Situação Lançamento"
                                        inputWidth="170px"
                                        options={OptionsSituacaoLancamento}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.lancamentoSituacaoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="novaTransformacao.tipo"
                                        title="Tipo do lançamento do financeiro no destino PAGAR ou RECEBER"
                                        text="Tipo"
                                        inputWidth="150px"
                                        options={EnumTipo}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.tipo}
                                        isEnum={true}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="novaTransformacao.lancamentoCentroCustoId"
                                        title={'Define o centro de custo padrão para o lançamento no destino'}
                                        text="Centro Custo"
                                        inputWidth="200px"
                                        options={OptionsLCC}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.lancamentoCentroCustoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Checkbox
                                        title="Calcular Impostos no destino do item"
                                        text="Calc Imposto"
                                        name="novaTransformacao.calculaImposto"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.calculaImposto}
                                        checked={!!novaTransformacao.calculaImposto}
                                    />
                                    <Select
                                        name="novaTransformacao.tipoCalculoImposto"
                                        title="Tipo do cálculo do imposto no destino do item"
                                        text="Tipo Cálculo"
                                        inputWidth="150px"
                                        options={EnumTipoCalculoImposto}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novaTransformacao.tipoCalculoImposto}
                                        isEnum={true}
                                        notOptNull={true}
                                    />
                                    <Checkbox
                                        title="operação de destino contábil"
                                        text="Contábil"
                                        name="novaTransformacao.contabil"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.contabil}
                                        checked={!!novaTransformacao.contabil}
                                    />
                                    <Checkbox
                                        title="operação de destino bloqueia movimento por limitte de crédito no centro de custo"
                                        text="Bloquear por centro de custo"
                                        name="novaTransformacao.centroCustoLimiteBloquear"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.centroCustoLimiteBloquear}
                                        checked={!!novaTransformacao.centroCustoLimiteBloquear}
                                    />
                                    <Checkbox
                                        title="obriga o movimento de destino a receber a transformação com plantão aberto"
                                        text="Plantão"
                                        name="novaTransformacao.plantao"
                                        handleOnChange={handleChange}
                                        value={novaTransformacao.plantao}
                                        checked={!!novaTransformacao.plantao}
                                    />

                                    <Button
                                        variant="contained"
                                        color="inherit"
                                        onClick={() => {
                                            limparRegistro('transformacao');
                                        }}
                                        style={{
                                            marginLeft: '10px',
                                            minWidth: '80px',
                                            fontSize: '14px',
                                            '@media (max-width: 600px)': {
                                                fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                                padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                            },
                                        }}
                                    >
                                        Limpar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color={novaTransformacao.funcao === 'cancelar' ? 'error' : 'info'}
                                        onClick={() => {
                                            handleRegistro(novaTransformacao, 'transformacao'); //handleTransformacao(novaTransformacao);
                                        }}
                                        disabled={novaTransformacao.funcao !== 'cancelar' && !novaTransformacao.operacaoId}
                                        style={{
                                            marginLeft: '10px',
                                            minWidth: '80px',
                                            fontSize: '14px',
                                            '@media (max-width: 600px)': {
                                                fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                                padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                            },
                                        }}
                                    >
                                        {novaTransformacao.funcao}
                                    </Button>
                                </div>
                                <h4>Papéis de Assinatura da Transformação</h4>
                                <div className={formStyles.form_group_checkbox}>
                                    {optionsPapeisAssinatura.map((papel) => (
                                        <Checkbox
                                            key={papel.id}
                                            name={`papel_transformacao_${papel.id}`}
                                            text={papel.descricao}
                                            handleOnChange={() => handleTogglePapelTransformacao(papel.id)}
                                            checked={papeisTransformacaoSelecionados.includes(papel.id)}
                                        />
                                    ))}
                                </div>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 100,
                                            },
                                            'mrt-row-numbers': {
                                                enableColumnOrdering: true, //turn on some features that are usually off
                                                enableResizing: true,
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontSize: '1.2rem',
                                                    },
                                                },
                                            },
                                            'mrt-row-select': {
                                                enableColumnActions: true,
                                                enableHiding: true,
                                                size: 50,
                                            },
                                        }}
                                        enableColumnFilterModes
                                        enableGlobalFilterModes
                                        //enableColumnResizing
                                        enableColumnOrdering
                                        enableEditing
                                        renderRowActions={({ row, table }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                <Tooltip arrow placement="top" title={'Editar'}>
                                                    <span>
                                                        {' '}
                                                        <IconButton
                                                            onClick={() => {
                                                                handleRegistroItem(
                                                                    row.original,
                                                                    row.index,
                                                                    'Editar',
                                                                    'transformacao'
                                                                );
                                                            }}
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            {<Edit />}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip arrow placement="right" title="Cancelar">
                                                    <span>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() =>
                                                                handleRegistroItem(
                                                                    row.original,
                                                                    row.id,
                                                                    'Cancelar',
                                                                    'transformacao'
                                                                )
                                                            }
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        columns={columnsTransformacao}
                                        data={operacaoTransformacoes}
                                        rowCount={rowCountTransformacao}
                                        //enableRowSelection
                                        getRowId={(row) => row.uuid}
                                        //manualFiltering
                                        manualPagination
                                        manualSorting
                                        muiToolbarAlertBannerProps={
                                            mrtTransformacao.isError
                                                ? {
                                                      color: 'error',
                                                      children: 'Error loading data',
                                                  }
                                                : undefined
                                        }
                                        onColumnFiltersChange={mrtTransformacao.setColumnFilters}
                                        onColumnFilterFnsChange={mrtTransformacao.setColumnFiltersMode}
                                        onGlobalFilterChange={mrtTransformacao.setGlobalFilter}
                                        onPaginationChange={mrtTransformacao.setPagination}
                                        onSortingChange={mrtTransformacao.setSorting}
                                        initialState={{
                                            showColumnFilters: true,
                                            density: 'compact',
                                            //columnPinning: { left: ["mrt-row-select"] },
                                        }}
                                        state={{
                                            columnFilterFns: mrtTransformacao.columnFilterFns,
                                            columnFilters: mrtTransformacao.columnFilters,
                                            globalFilter: mrtTransformacao.globalFilter,
                                            isLoading: mrtTransformacao.isLoading,
                                            pagination: mrtTransformacao.pagination,
                                            showAlertBanner: mrtTransformacao.isError,
                                            showProgressBars: mrtTransformacao.isRefetching,
                                            sorting: mrtTransformacao.sorting,
                                        }}
                                        //positionToolbarDropZone={"top"}
                                        positionExpandColumn={'first'}
                                        positionActionsColumn={'first'}
                                        positionToolbarAlertBanner="bottom"
                                        localization={MRT_Localization_PT_BR}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    {/* Entradas */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de movimentações de entradas</h4>
                            <div>
                                <Checkbox
                                    title="Informa que o movimento altera o estoque"
                                    text="Altera Estoque"
                                    name="alteraEstoque"
                                    handleOnChange={handleChange}
                                    value={dados.alteraEstoque}
                                    checked={!!dados.alteraEstoque}
                                />
                                <Checkbox
                                    title="Verifica o estoque na operação e valida o saldo, caso a opção esteja marcada vai permitir com saldo negativo"
                                    text="Estoque Negativo"
                                    name="estoqueNegativo"
                                    handleOnChange={handleChange}
                                    value={dados.estoqueNegativo}
                                    checked={!!dados.estoqueNegativo}
                                />
                                <Input
                                    text="Estoque"
                                    type="range"
                                    name="estoque"
                                    inputWidth="100px"
                                    title="configura o valor que a operação altera o estqoue, -1 subtrai, 0 não altera e 1 acrescenta"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.estoque}
                                    textAlign="center"
                                    min={-1}
                                    max={1}
                                />
                                <Select
                                    name="almoxarifadoId"
                                    title="Define o almoxarifado padrão para a operação"
                                    text="Almoxarifado"
                                    inputWidth="170px"
                                    options={OptionsAlmoxarifado}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.almoxarifadoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="situacaoIdAlmoxarifado"
                                    title="Define a situação padrão do movimento"
                                    text="Situação Almoxarifado"
                                    inputWidth="170px"
                                    options={OptionsSituacaoAlmoxarifado}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.situacaoIdAlmoxarifado}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Estoque bloqueado"
                                    text="Estqoue Bloqueado"
                                    name="estoqueBloqueado"
                                    handleOnChange={handleChange}
                                    value={dados.estoqueBloqueado}
                                    checked={!!dados.estoqueBloqueado}
                                />
                                <Checkbox
                                    title="Obriga conferência"
                                    text="Conferencia"
                                    name="conferencia"
                                    handleOnChange={handleChange}
                                    value={dados.conferencia}
                                    checked={!!dados.conferencia}
                                />
                            </div>
                            <h4>Assinaturas</h4>
                            <div>
                                <Checkbox
                                    title="A transformação não exigirá assinaturas"
                                    text="Libera Assinatura"
                                    name="liberaAssinatura"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.liberaAssinatura}
                                    checked={!!dados.liberaAssinatura}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    {/* Saídas */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de movimentações de saídas</h4>
                            <div>
                                <Checkbox
                                    title="Informa que o movimento altera o estoque"
                                    text="Altera Estoque"
                                    name="alteraEstoque"
                                    handleOnChange={handleChange}
                                    value={dados.alteraEstoque}
                                    checked={!!dados.alteraEstoque}
                                />
                                <Checkbox
                                    title="Verifica o estoque na operação de destino e valida o saldo, caso a opção esteja marcada vai permitir com saldo negativo"
                                    text="Estoque Negativo"
                                    name="estoqueNegativo"
                                    handleOnChange={handleChange}
                                    value={dados.estoqueNegativo}
                                    checked={!!dados.estoqueNegativo}
                                />
                                <Input
                                    text="Estoque"
                                    type="range"
                                    name="estoque"
                                    inputWidth="100px"
                                    title="configura o valor que a operação altera o estqoue, -1 subtrai, 0 não altera e 1 acrescenta"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.estoque}
                                    textAlign="center"
                                    min={-1}
                                    max={1}
                                />
                                <Select
                                    name="almoxarifadoId"
                                    title="Define o almoxarifado padrão para a operação"
                                    text="Almoxarifado"
                                    inputWidth="170px"
                                    options={OptionsAlmoxarifado}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.almoxarifadoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="situacaoIdAlmoxarifado"
                                    title="Define a situação padrão do movimento"
                                    text="Situação Almoxarifado"
                                    inputWidth="170px"
                                    options={OptionsSituacaoAlmoxarifado}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.situacaoIdAlmoxarifado}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Estoque bloqueado"
                                    text="Estqoue Bloqueado"
                                    name="estoqueBloqueado"
                                    handleOnChange={handleChange}
                                    value={dados.estoqueBloqueado}
                                    checked={!!dados.estoqueBloqueado}
                                />
                                <Checkbox
                                    title="Obriga conferência"
                                    text="Conferencia"
                                    name="conferencia"
                                    handleOnChange={handleChange}
                                    value={dados.conferencia}
                                    checked={!!dados.conferencia}
                                />
                            </div>
                            <h4>Assinaturas</h4>
                            <div>
                                <Checkbox
                                    title="A transformação não exigirá assinaturas"
                                    text="Libera Assinatura"
                                    name="liberaAssinatura"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.liberaAssinatura}
                                    checked={!!dados.liberaAssinatura}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    {/* Serviço */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de movimentações de serviço</h4>
                        </div>
                    </TabPanel>
                    {/* Locação */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de movimentações de locação</h4>
                        </div>
                    </TabPanel>
                    {/* Indústria */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros para o modulo de indústria</h4>
                            <div>
                                <div>
                                    <Checkbox
                                        title="Informa que o movimento altera o estoque"
                                        text="Altera Estoque"
                                        name="alteraEstoque"
                                        handleOnChange={handleChange}
                                        value={dados.alteraEstoque}
                                        checked={!!dados.alteraEstoque}
                                    />
                                    <Checkbox
                                        title="Verifica o estoque na operação de destino e valida o saldo, caso a opção esteja marcada vai permitir com saldo negativo"
                                        text="Estoque Negativo"
                                        name="estoqueNegativo"
                                        handleOnChange={handleChange}
                                        value={dados.estoqueNegativo}
                                        checked={!!dados.estoqueNegativo}
                                    />
                                    <Input
                                        text="Estoque"
                                        type="range"
                                        name="estoque"
                                        inputWidth="100px"
                                        title="configura o valor que a operação altera o estqoue, -1 subtrai, 0 não altera e 1 acrescenta"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.estoque}
                                        textAlign="center"
                                        min={-1}
                                        max={1}
                                    />
                                    <Select
                                        name="almoxarifadoId"
                                        title="Define o almoxarifado padrão para a operação"
                                        text="Almoxarifado"
                                        inputWidth="170px"
                                        options={OptionsAlmoxarifado}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.almoxarifadoId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Select
                                        name="situacaoIdAlmoxarifado"
                                        title="Define a situação padrão do movimento"
                                        text="Situação Almoxarifado"
                                        inputWidth="170px"
                                        options={OptionsSituacaoAlmoxarifado}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.situacaoIdAlmoxarifado}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <Checkbox
                                        title="Estoque bloqueado"
                                        text="Estqoue Bloqueado"
                                        name="estoqueBloqueado"
                                        handleOnChange={handleChange}
                                        value={dados.estoqueBloqueado}
                                        checked={!!dados.estoqueBloqueado}
                                    />
                                    <Checkbox
                                        title="Obriga conferência"
                                        text="Conferencia"
                                        name="conferencia"
                                        handleOnChange={handleChange}
                                        value={dados.conferencia}
                                        checked={!!dados.conferencia}
                                    />
                                </div>
                                <h4>Assinaturas</h4>
                                <div>
                                    <Checkbox
                                        title="A transformação não exigirá assinaturas"
                                        text="Libera Assinatura"
                                        name="liberaAssinatura"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.liberaAssinatura}
                                        checked={!!dados.liberaAssinatura}
                                    />
                                </div>
                            </div>
                            <div>
                                <Checkbox
                                    title="Informa se a entrada de matéria-prima estoca no almoxarifado de grãos"
                                    text="MP Est Grãos"
                                    name="materiaPrimaEstocaGraos"
                                    handleOnChange={handleChange}
                                    value={dados.materiaPrimaEstocaGraos}
                                    checked={!!dados.materiaPrimaEstocaGraos}
                                />
                                <Select
                                    name="centroCustoMateriaPrimaId"
                                    title={'Define o centro de custo padrão para entrada de matéria-prima'}
                                    text="Centro Custo MP"
                                    options={OptionsCCI}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoMateriaPrimaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Informa se o refugo vai gerar valor a receber no modulo financeiro"
                                    text="Refugo MP gera financeiro"
                                    name="refugoMateriaPrimaGeraFinanceiro"
                                    handleOnChange={handleChange}
                                    value={dados.refugoMateriaPrimaGeraFinanceiro}
                                    checked={!!dados.refugoMateriaPrimaGeraFinanceiro}
                                />
                                <Select
                                    name="formaRefugoId"
                                    title={'Define a forma de recebimento padrão para o refugo da matéria-prima'}
                                    text="Forma Refugo"
                                    options={OptionsForma}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.formaRefugoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="prazoRefugoId"
                                    title={'Define o prazo padrão para o refugo da matéria-prima'}
                                    text="Prazo Refugo"
                                    options={OptionsPrazo}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.prazoRefugoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <DataList
                                    text="Tabela de Preços"
                                    title={'Digite para selecionar a tabela de preço'}
                                    placeholder="Tabela de preço"
                                    name="refugo.tabelaPreco.descricao"
                                    inputWidth="150px"
                                    filteredOptions={OptionsTabelaPreco}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={tabelaPreco?.refugo?.descricao || ''}
                                />
                                <Select
                                    name="centroCustoRefugoMateriaPrimaId"
                                    title={'Define o centro de custo padrão para o refugo da matéria-prima'}
                                    text="Centro Custo Refugo"
                                    options={OptionsCCI}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoRefugoMateriaPrimaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    {/* Manutenção */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de Manutenção</h4>
                            <h4>Assinaturas</h4>
                            <div>
                                <Checkbox
                                    title="A transformação não exigirá assinaturas"
                                    text="Libera Assinatura"
                                    name="liberaAssinatura"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.liberaAssinatura}
                                    checked={!!dados.liberaAssinatura}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    {/* Balanço */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros do balanço</h4>
                            <div>
                                <Checkbox
                                    title="Indica que o balanço dos itens é uma Operação Contábil/Fiscal"
                                    text="Contábil"
                                    name="contabil"
                                    handleOnChange={handleChange}
                                    value={dados.contabil}
                                    checked={!!dados.contabil}
                                />
                                <Checkbox
                                    title="Informa que o movimento altera o estoque"
                                    text="Altera Estoque"
                                    name="alteraEstoque"
                                    handleOnChange={handleChange}
                                    value={dados.alteraEstoque}
                                    checked={!!dados.alteraEstoque}
                                />
                                <Checkbox
                                    title="Informa que o balanço pode bloquear o movimento do item durante a contagem, liberando somente após a aplicação das contagens do balanço, ou seja, apenas ao final do balanço consolidando o estoque"
                                    text="Bloqueia movimento"
                                    name="balancoBloqueiaEstoqueDuranteContagem"
                                    handleOnChange={handleChange}
                                    value={dados.balancoBloqueiaEstoqueDuranteContagem}
                                    checked={!!dados.balancoBloqueiaEstoqueDuranteContagem}
                                />
                                <Select
                                    name="situacaoIdAlmoxarifado"
                                    title="Define a situação padrão do movimento"
                                    text="Situação Almoxarifado"
                                    inputWidth="170px"
                                    options={OptionsSituacaoAlmoxarifado}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.situacaoIdAlmoxarifado}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    {/* Documento */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Documentos modelo vinculados à operação</h4>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Select
                                    name="novoDocumento.documentoId"
                                    title={`escolha o documento modelo para o relatório`}
                                    text="Modelo"
                                    inputWidth="100"
                                    options={OptionsDocumento}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoDocumento.documentoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Ativo quando marcado"
                                    text="Ativo"
                                    name="novoDocumento.ativo"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoDocumento.ativo}
                                    checked={!!novoDocumento.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparRegistro('documento');
                                    }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novoDocumento.funcao === 'cancelar' ? 'error' : 'info'}
                                    onClick={() => {
                                        handleRegistro(novoDocumento, 'documento');
                                    }}
                                    disabled={novoDocumento.funcao !== 'cancelar' && !novoDocumento.documentoId}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novoDocumento.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 100,
                                            },
                                            'mrt-row-numbers': {
                                                enableColumnOrdering: true, //turn on some features that are usually off
                                                enableResizing: true,
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontSize: '1.2rem',
                                                    },
                                                },
                                            },
                                            'mrt-row-select': {
                                                enableColumnActions: true,
                                                enableHiding: true,
                                                size: 50,
                                            },
                                        }}
                                        enableColumnFilterModes
                                        enableGlobalFilterModes
                                        //enableColumnResizing
                                        enableColumnOrdering
                                        enableEditing
                                        renderRowActions={({ row, table }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                <Tooltip arrow placement="top" title={'Editar'}>
                                                    <span>
                                                        {' '}
                                                        <IconButton
                                                            onClick={() => {
                                                                handleRegistroItem(
                                                                    row.original,
                                                                    row.index,
                                                                    'Editar',
                                                                    'documento'
                                                                );
                                                            }}
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            {<Edit />}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip arrow placement="right" title="Cancelar">
                                                    <span>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() =>
                                                                handleRegistroItem(row.original, row.id, 'Cancelar', 'documento')
                                                            }
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        columns={columnsDocumento}
                                        data={operacaoParametrosDocumentos}
                                        rowCount={rowCount}
                                        enableRowSelection
                                        getRowId={(row) => row.uuid}
                                        //manualFiltering
                                        manualPagination
                                        manualSorting
                                        muiToolbarAlertBannerProps={
                                            mrtDocumento.isError
                                                ? {
                                                      color: 'error',
                                                      children: 'Error loading data',
                                                  }
                                                : undefined
                                        }
                                        onColumnFiltersChange={mrtDocumento.setColumnFilters}
                                        onColumnFilterFnsChange={mrtDocumento.setColumnFiltersMode}
                                        onGlobalFilterChange={mrtDocumento.setGlobalFilter}
                                        onPaginationChange={mrtDocumento.setPagination}
                                        onSortingChange={mrtDocumento.setSorting}
                                        initialState={{
                                            showColumnFilters: true,
                                            density: 'compact',
                                            //columnPinning: { left: ["mrt-row-select"] },
                                        }}
                                        state={{
                                            columnFilterFns: mrtDocumento.columnFilterFns,
                                            columnFilters: mrtDocumento.columnFilters,
                                            globalFilter: mrtDocumento.globalFilter,
                                            isLoading: mrtDocumento.isLoading,
                                            pagination: mrtDocumento.pagination,
                                            showAlertBanner: mrtDocumento.isError,
                                            showProgressBars: mrtDocumento.isRefetching,
                                            sorting: mrtDocumento.sorting,
                                        }}
                                        //positionToolbarDropZone={"top"}
                                        positionExpandColumn={'first'}
                                        positionActionsColumn={'first'}
                                        positionToolbarAlertBanner="bottom"
                                        localization={MRT_Localization_PT_BR}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    {/* Tabelas de preços relacionadas*/}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Tabelas de preços vinculadas à operação</h4>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <SelectEmpresa
                                    name="novaTabelaPreco.empresaId"
                                    title={`escolha a empresa`}
                                    text="Empresa"
                                    inputWidth="100"
                                    options={OptionsEmpresa}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaTabelaPreco.empresaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <DataList
                                    text="Tabela de Preços"
                                    title={'Digite para selecionar a tabela de preço'}
                                    placeholder="Tabela de preço"
                                    name="tabelapreco.tabelaPreco.descricao"
                                    inputWidth="250px"
                                    filteredOptions={OptionsTabelaPreco}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={tabelaPreco?.tabelapreco?.descricao || ''}
                                />
                                <Checkbox
                                    title="Ativo quando marcado"
                                    text="Ativo"
                                    name="novaTabelaPreco.ativo"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaTabelaPreco.ativo}
                                    checked={!!novaTabelaPreco.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparRegistro('tabelapreco');
                                    }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novaTabelaPreco.funcao === 'cancelar' ? 'error' : 'info'}
                                    onClick={() => {
                                        handleRegistro(novaTabelaPreco, 'tabelapreco');
                                    }}
                                    disabled={novaTabelaPreco.funcao !== 'cancelar' && !novaTabelaPreco.tabelaPrecoId}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novaTabelaPreco.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 100,
                                            },
                                            'mrt-row-numbers': {
                                                enableColumnOrdering: true, //turn on some features that are usually off
                                                enableResizing: true,
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontSize: '1.2rem',
                                                    },
                                                },
                                            },
                                            'mrt-row-select': {
                                                enableColumnActions: true,
                                                enableHiding: true,
                                                size: 50,
                                            },
                                        }}
                                        enableColumnFilterModes
                                        enableGlobalFilterModes
                                        //enableColumnResizing
                                        enableColumnOrdering
                                        enableEditing
                                        renderRowActions={({ row, table }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                <Tooltip arrow placement="top" title={'Editar'}>
                                                    <span>
                                                        {' '}
                                                        <IconButton
                                                            onClick={() => {
                                                                handleRegistroItem(
                                                                    row.original,
                                                                    row.index,
                                                                    'Editar',
                                                                    'tabelapreco'
                                                                );
                                                            }}
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            {<Edit />}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip arrow placement="right" title="Cancelar">
                                                    <span>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() =>
                                                                handleRegistroItem(
                                                                    row.original,
                                                                    row.id,
                                                                    'Cancelar',
                                                                    'tabelapreco'
                                                                )
                                                            }
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        columns={columnsTabelaPreco}
                                        data={operacaoTabelaPrecos}
                                        rowCount={rowCountTB}
                                        enableRowSelection
                                        getRowId={(row) => row.uuid}
                                        //manualFiltering
                                        manualPagination
                                        manualSorting
                                        muiToolbarAlertBannerProps={
                                            mrtTabelaPreco.isError
                                                ? {
                                                      color: 'error',
                                                      children: 'Error loading data',
                                                  }
                                                : undefined
                                        }
                                        onColumnFiltersChange={mrtTabelaPreco.setColumnFilters}
                                        onColumnFilterFnsChange={mrtTabelaPreco.setColumnFiltersMode}
                                        onGlobalFilterChange={mrtTabelaPreco.setGlobalFilter}
                                        onPaginationChange={mrtTabelaPreco.setPagination}
                                        onSortingChange={mrtTabelaPreco.setSorting}
                                        initialState={{
                                            showColumnFilters: true,
                                            density: 'compact',
                                            //columnPinning: { left: ["mrt-row-select"] },
                                        }}
                                        state={{
                                            columnFilterFns: mrtTabelaPreco.columnFilterFns,
                                            columnFilters: mrtTabelaPreco.columnFilters,
                                            globalFilter: mrtTabelaPreco.globalFilter,
                                            isLoading: mrtTabelaPreco.isLoading,
                                            pagination: mrtTabelaPreco.pagination,
                                            showAlertBanner: mrtTabelaPreco.isError,
                                            showProgressBars: mrtTabelaPreco.isRefetching,
                                            sorting: mrtTabelaPreco.sorting,
                                        }}
                                        //positionToolbarDropZone={"top"}
                                        positionExpandColumn={'first'}
                                        positionActionsColumn={'first'}
                                        positionToolbarAlertBanner="bottom"
                                        localization={MRT_Localization_PT_BR}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    {/* Situações Permitidas */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Situações permitidas para vinculos com a operação</h4>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Select
                                    name="novaSituacao.situacaoId"
                                    title={`escolha a situação permitida para esta operação`}
                                    text="Situação"
                                    inputWidth="100"
                                    options={OptionsAllSituacoes}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaSituacao.situacaoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Ativo quando marcado"
                                    text="Ativo"
                                    name="novaSituacao.ativo"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaSituacao.ativo}
                                    checked={!!novaSituacao.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparRegistro('situacao');
                                    }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novaSituacao.funcao === 'cancelar' ? 'error' : 'info'}
                                    onClick={() => {
                                        handleRegistro(novaSituacao, 'situacao');
                                    }}
                                    disabled={novaSituacao.funcao !== 'cancelar' && !novaSituacao.situacaoId}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novaSituacao.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 100,
                                            },
                                            'mrt-row-numbers': {
                                                enableColumnOrdering: true, //turn on some features that are usually off
                                                enableResizing: true,
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontSize: '1.2rem',
                                                    },
                                                },
                                            },
                                            'mrt-row-select': {
                                                enableColumnActions: true,
                                                enableHiding: true,
                                                size: 50,
                                            },
                                        }}
                                        enableColumnFilterModes
                                        enableGlobalFilterModes
                                        enableColumnOrdering
                                        enableEditing
                                        renderRowActions={({ row, table }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                <Tooltip arrow placement="top" title={'Editar'}>
                                                    <span>
                                                        {' '}
                                                        <IconButton
                                                            onClick={() => {
                                                                handleRegistroItem(row.original, row.index, 'Editar', 'situacao');
                                                            }}
                                                            disabled={!podeEditar()}
                                                        >
                                                            {<Edit />}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip arrow placement="right" title="Cancelar">
                                                    <span>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() =>
                                                                handleRegistroItem(row.original, row.id, 'Cancelar', 'situacao')
                                                            }
                                                            disabled={!podeEditar()}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        columns={columnsSituacao}
                                        data={situacaoPermitida}
                                        rowCount={mrtSituacao.rowCount}
                                        enableRowSelection
                                        getRowId={(row) => row.uuid}
                                        //manualFiltering
                                        manualPagination
                                        manualSorting
                                        muiToolbarAlertBannerProps={
                                            mrtSituacao.isError
                                                ? {
                                                      color: 'error',
                                                      children: 'Error loading data',
                                                  }
                                                : undefined
                                        }
                                        onColumnFiltersChange={mrtSituacao.setColumnFilters}
                                        onColumnFilterFnsChange={mrtSituacao.setColumnFiltersMode}
                                        onGlobalFilterChange={mrtSituacao.setGlobalFilter}
                                        onPaginationChange={mrtSituacao.setPagination}
                                        onSortingChange={mrtSituacao.setSorting}
                                        initialState={{
                                            showColumnFilters: true,
                                            density: 'compact',
                                            //columnPinning: { left: ["mrt-row-select"] },
                                        }}
                                        state={{
                                            columnFilterFns: mrtSituacao.columnFilterFns,
                                            columnFilters: mrtSituacao.columnFilters,
                                            globalFilter: mrtSituacao.globalFilter,
                                            isLoading: mrtSituacao.isLoading,
                                            pagination: mrtSituacao.pagination,
                                            showAlertBanner: mrtSituacao.isError,
                                            showProgressBars: mrtSituacao.isRefetching,
                                            sorting: mrtSituacao.sorting,
                                        }}
                                        //positionToolbarDropZone={"top"}
                                        positionExpandColumn={'first'}
                                        positionActionsColumn={'first'}
                                        positionToolbarAlertBanner="bottom"
                                        localization={MRT_Localization_PT_BR}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    {/* Operações Permitidas */}
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Operações permitidas para vinculos com a operação</h4>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Select
                                    name="novaOperacao.operacaoId"
                                    title={`escolha a operação permitida`}
                                    text="Operação"
                                    inputWidth="100"
                                    options={OptionsAllOperacoes}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaOperacao.operacaoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Ativo quando marcado"
                                    text="Ativo"
                                    name="novaOperacao.ativo"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaOperacao.ativo}
                                    checked={!!novaOperacao.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparRegistro('operacao');
                                    }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novaOperacao.funcao === 'cancelar' ? 'error' : 'info'}
                                    onClick={() => {
                                        handleRegistro(novaOperacao, 'operacao');
                                    }}
                                    disabled={novaOperacao.funcao !== 'cancelar' && !novaOperacao.operacaoId}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novaOperacao.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 100,
                                            },
                                            'mrt-row-numbers': {
                                                enableColumnOrdering: true, //turn on some features that are usually off
                                                enableResizing: true,
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontSize: '1.2rem',
                                                    },
                                                },
                                            },
                                            'mrt-row-select': {
                                                enableColumnActions: true,
                                                enableHiding: true,
                                                size: 50,
                                            },
                                        }}
                                        enableColumnFilterModes
                                        enableGlobalFilterModes
                                        enableColumnOrdering
                                        enableEditing
                                        renderRowActions={({ row, table }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                <Tooltip arrow placement="top" title={'Editar'}>
                                                    <span>
                                                        {' '}
                                                        <IconButton
                                                            onClick={() => {
                                                                handleRegistroItem(row.original, row.index, 'Editar', 'operacao');
                                                            }}
                                                            disabled={!podeEditar()}
                                                        >
                                                            {<Edit />}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip arrow placement="right" title="Cancelar">
                                                    <span>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() =>
                                                                handleRegistroItem(row.original, row.id, 'Cancelar', 'operacao')
                                                            }
                                                            disabled={!podeEditar()}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        columns={columnsOperacao}
                                        data={operacaoPermitida}
                                        rowCount={mrtOperacao.rowCount}
                                        enableRowSelection
                                        getRowId={(row) => row.uuid}
                                        //manualFiltering
                                        manualPagination
                                        manualSorting
                                        muiToolbarAlertBannerProps={
                                            mrtOperacao.isError
                                                ? {
                                                      color: 'error',
                                                      children: 'Error loading data',
                                                  }
                                                : undefined
                                        }
                                        onColumnFiltersChange={mrtOperacao.setColumnFilters}
                                        onColumnFilterFnsChange={mrtOperacao.setColumnFiltersMode}
                                        onGlobalFilterChange={mrtOperacao.setGlobalFilter}
                                        onPaginationChange={mrtOperacao.setPagination}
                                        onSortingChange={mrtOperacao.setSorting}
                                        initialState={{
                                            showColumnFilters: true,
                                            density: 'compact',
                                            //columnPinning: { left: ["mrt-row-select"] },
                                        }}
                                        state={{
                                            columnFilterFns: mrtOperacao.columnFilterFns,
                                            columnFilters: mrtOperacao.columnFilters,
                                            globalFilter: mrtOperacao.globalFilter,
                                            isLoading: mrtOperacao.isLoading,
                                            pagination: mrtOperacao.pagination,
                                            showAlertBanner: mrtOperacao.isError,
                                            showProgressBars: mrtOperacao.isRefetching,
                                            sorting: mrtOperacao.sorting,
                                        }}
                                        //positionToolbarDropZone={"top"}
                                        positionExpandColumn={'first'}
                                        positionActionsColumn={'first'}
                                        positionToolbarAlertBanner="bottom"
                                        localization={MRT_Localization_PT_BR}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Tooltip arrow placement="top-start" title="Voltar">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() =>
                                        navigate(caminhoVoltar, {
                                            ul: urlParams.get('ul'),
                                            li: urlParams.get('li'),
                                            tipo: urlParams.get('tipo'),
                                        })
                                    }
                                >
                                    Voltar
                                </Button>
                            </Tooltip>
                            <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                //disabled={}
                            >
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
